import '../css/MainMenu.scss'
import '../css/SinglePlayer.scss'
import '../css/LevelBanner.scss'
import '../css/ScrollBar.scss'
import '../css/VehicleSelect.scss'
import '../css/CharacterSelect.scss'
import '../css/SocialShare.scss'
import '../css/LoginScreen.scss'
import '../css/PauseScreen.scss'
import '../css/WinScreen.scss'
import '../css/GameOver.scss'
import '../css/Leaderboard.scss'
import '../css/LevelComments.scss'
import '../css/SettingsMenu.scss'
import '../css/YoutubePlayer.scss'
import '../css/UserPage.scss'
import '../css/DiscordJoin.scss'
import '../css/ServerDown.scss'
import '../css/flags.css'

// https://github.com/catdad/canvas-confetti

import {
    backendManager
} from '../utils/BackendManager';
import * as BackendCache from '../utils/BackendCacheManager'

import {
    game
} from '../Game';
import * as dat from '../../libs/dat.gui';
import * as uiHelper from '../b2Editor/utils/uiHelper';
import * as format from '../b2Editor/utils/formatString';
import {
    Settings
} from '../Settings'
import {
    hashName
} from '../AssetList';
import * as MobileController from '../utils/MobileController';
import * as SaveManager from "../utils/SaveManager"
import {vocalsLockedOff} from '../utils/platformDefaults';
import { YouTubePlayer } from '../utils/YouTubePlayer';
import * as AudioManager from "../utils/AudioManager"
import {CharacterSelectionVoice} from '../utils/CharacterSelectionVoice';
import SimpleBar from 'simplebar'
import {countries, localize} from '../utils/Localization'

import * as betterLocalStorage from '../utils/LocalStorageWrapper'
import { cleanMods, getCustomModdedPortrait, getModdedPortrait, init as initModManager, refreshVoiceMods } from '../utils/ModManager'
import { destroyAllAds, getAdContainer, updateDisplayAds } from '../utils/AdManager'
import { generateLobby, updateLobbyUI } from './lobby'
import { generateLobbyBrowser, hideLobbyBrowser, showLobbyBrowser } from './lobbyBrowser'
import { adminReturnToLobby, LOBBY_STATE, multiplayerState, requestGameState, returnToLobby, returnToMultiplayer, selectMultiplayerLevel, sendSimpleMessageAll } from '../multiplayer/multiplayerManager'
import { SIMPLE_MESSAGE_TYPES } from '../multiplayer/schemas'
import { saveRecentlyPlayed } from '../utils/RecentlyPlayedManager'
import { HUD_STATES, setMultiplayerHud } from '../multiplayer/hud'
import { createMenuEntrance } from './menuEntrance'
import { ControlsPanel } from './ControlsPanel'
import { MobileControlsPanel } from './MobileControlsPanel'
import { input } from '../input/InputManager'
import { bindingLabel } from '../input/bindings'
import { configureMenuNavigation } from './menuNavigation'
import { installExternalLinkRouting, openExternalLink } from '../utils/ExternalLinks'
import * as ReplayManager from '../utils/ReplayManager'
import { shareReplayLink } from './ReplayControls'
import { showXPGain } from './XPToast'
import { levelProgress, nextRank, rankForLevel, RANKS, showRankIcon, xpToNextLevel } from '../utils/Ranks'
import { watchAdminTools } from '../admin/watchAdminTools'

let customGUIContainer = document.getElementById('game-ui-container');
let imageObserver = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) {
    const thumb = entry.target.querySelector('.thumb');
    thumb.style.backgroundImage = `url(${thumb.getAttribute('data-src')})`;
    entry.target.classList.add('loaded')
    imageObserver.unobserve(entry.target);
    }
}));
let mainMenu;
let mainMenuEntrance;
let singlePlayer;
let discordButton;
let gameOver;
let levelLoader;
let levelBanner;
let adContainer;
let levelBannerYTFeed;
let youtubePlayer;
let characterSelect;
const characterSelectionVoice = new CharacterSelectionVoice(AudioManager);
let vehicleSelect;
let pauseScreen;
let filterMenu;
let winScreen;
let winLogo;
let socialShareScreen;
let settingsMenu;
let controlsPanel;
let loginScreen;
let leaderboard;
let levelComments;
let levelCommentsView = 0;
let levelCommentsLevel;
let userPage;
let userPageRequest = 0;
let smallLogo;
let inGameRetryButton;
let inGamePauseButton;
let skipTutorial;
let discordJoin;
let serverDown;
let mainMenuActive = 'main';

const discordInviteUrl = 'https://discord.gg/7ZWxBam9Hx';
const discordServerUrl = 'https://discord.com/channels/762397258897162260';

let lastSearch = '';
let singlePlayerRequest = 0;
let initialLevelBatch = [];
// Promoted levels lead the list until the player changes a filter.
let showPromotedLevels = true;

// Set by the admin tools, which only load for admins who open the game with ?admin.
let admin = null;
const levelTiles = new WeakMap();
let levelBannerLevel;
let userPageProfile;

function UIManager() {
    installExternalLinkRouting();
    const totalXP = level => {
        let xp = 0;
        for(let l = 0; l < level; l++) xp += xpToNextLevel(l);
        return xp;
    };
    const demoStanding = xp => {
        const progress = levelProgress(xp);
        return {xp, level: progress.level, level_xp: progress.xp, level_xp_needed: progress.needed, rank: 12, ranked: 1541};
    };
    const demoJoin = () => backendManager.needsDiscordJoin() ? () => this.joinDiscord() : null;
    window.xpDemo = {
        gain: (level = 12) => showXPGain(200, demoStanding(totalXP(level) + Math.max(200, Math.floor(xpToNextLevel(level) * .6))), demoJoin()),
        levelUp: (level = 12) => showXPGain(200, demoStanding(totalXP(level) + 80), demoJoin()),
        discord: (inGuild = false) => {
            if(!backendManager.userData) return console.log('Log in first');
            backendManager.userData.in_guild = inGuild;
            this.updateDiscordPrompts();
        },
        discordPopup: (state = 'invite') => this.showDiscordJoin(state),
        profile: (level = 60) => {
            if(userPage?.style.display !== 'grid') return console.log('Open a profile page first');
            this.setUserPageRank(level < 0 ? null : demoStanding(totalXP(level) + Math.floor(xpToNextLevel(level) * .6)));
        },
    };

    var self = this;

    this.showMainMenu = () =>{
        if(!mainMenu){
            const htmlStructure = /*html*/`
                <div class="header">
                    <div class="settings"></div>
                    <div class="logo"></div>
                    <div class="audio"></div>
                </div>
                <div class="menu-grid">
                    <div class="singleplayer-but h2 v2"><span>${localize('mainmenu_singleplayer')}<span></div>
                    <div class="characters-but h1 v1"><span>${localize('mainmenu_characters')}</span><div class="character-image"></div></div>
                    <div class="discord-but h1 v1"><div class="profile-rank" aria-hidden="true"><div class="profile-rank-icon"></div><div class="profile-rank-level"></div></div><span class="profile-name">${localize('mainmenu_signup')}</span></div>
                    <div class="multiplayer-but h2 v2"><span>${localize('mainmenu_multiplayer')}<span></div>
                    <div class="editor-but h2 v1"><span>${localize('mainmenu_createlevels')}</span><span class="available-pc">${localize('mainmenu_availablepc')}</span></div>
                </div>
                <div class="discord-strip" hidden>
                    <div class="discord-strip-rank" aria-hidden="true"></div>
                    <div class="discord-strip-text">
                        <div class="discord-strip-title"></div>
                        <div class="discord-strip-body"></div>
                    </div>
                    <button type="button" class="discord-strip-join"><span class="discord-glyph" aria-hidden="true"></span><span class="label">${localize('discord_join')}</span></button>
                    <button type="button" class="discord-strip-hide" aria-label="${localize('discord_hide')}"></button>
                </div>
                <div class="multiplayer-browser"></div>
                <div class="multiplayer-lobby"></div>
                ${this.getFooter()}
            `

            mainMenu = document.createElement('div');
            mainMenu.classList.add('mainmenu');
            mainMenu.innerHTML = htmlStructure;
            mainMenuEntrance = createMenuEntrance(mainMenu);

            mainMenu.querySelector('.multiplayer-browser').appendChild(generateLobbyBrowser());
            mainMenu.querySelector('.multiplayer-lobby').appendChild(generateLobby());

            // header
            const header = mainMenu.querySelector('.header');
            const settings = header.querySelector('.settings');
            settings.onclick = ()=> {
                this.hideCharacterSelect();
                this.showSettingsMenu();
            }

            // buttons main
            const grid = mainMenu.querySelector('.menu-grid');
            const singleplayerBut = grid.querySelector('.singleplayer-but');
            singleplayerBut.onclick = () => {
                this.hideMainMenu();
                game.openSinglePlayer();
            }

            const multiplayerBut = grid.querySelector('.multiplayer-but');
            multiplayerBut.onclick = () => {
                this.setMainMenuActive('multiplayer');
            }

            const editorBut = grid.querySelector('.editor-but');
            if(MobileController.isMobile()){
                editorBut.classList.add('mobile');
            }else{
                editorBut.onclick = ()=> {
                    this.hideMainMenu();
                    game.openEditor();
                }
            }

            const characterSelect = grid.querySelector('.characters-but');
            characterSelect.onclick = ()=> {
                this.hideSettingsMenu();
                this.showCharacterSelect();
            }

            const discordButton = grid.querySelector('.discord-but');
            discordButton.onclick = ()=>{
                if(!backendManager.isLoggedIn()){
                    this.openDiscordOauth();
                } else if(!backendManager.userData){
                    backendManager.checkServer();
                } else {
                    this.hideMainMenu();
                    game.openSinglePlayer();
                    this.showUserPage(backendManager.userData.username, 'favorite');
                }
            }

            const discordStrip = mainMenu.querySelector('.discord-strip');
            discordStrip.querySelector('.discord-strip-join').onclick = () => this.joinDiscord();
            discordStrip.querySelector('.discord-strip-hide').onclick = () => {
                const userData = SaveManager.getLocalUserdata();
                userData.discordStripHiddenUntil = Date.now() + 14 * 24 * 60 * 60 * 1000;
                SaveManager.updateLocalUserData(userData);
                this.updateDiscordPrompts();
            };

            // misc
            backendManager.registerListener('login', ()=>this.handleLoginChange());
            backendManager.registerListener('logout', ()=>this.handleLoginChange());
            for(const event of ['userdata', 'discord', 'xp']) backendManager.registerListener(event, () => this.updateDiscordPrompts());
            backendManager.registerListener('serverstatus', ({down}) => down ? this.showServerDown() : this.hideServerDown());
            if(backendManager.serverDown) this.showServerDown();
            watchAdminTools(this, backendManager);
            this.handleLoginChange();

            this.gridOnlyEvenCells = ()=>{
                if(mainMenu.style.display !== 'block') return;

                const gridCellWidth = parseFloat(getComputedStyle(characterSelect).width);
                const gap = parseFloat(getComputedStyle(grid).columnGap);

                const fourCellGridWidth = gridCellWidth * 4 + gap * 3;
                // Let CSS size the tracks exactly; serializing fractional pixel
                // widths can make auto-fit drop an entire column after rounding.
                const columns = fourCellGridWidth <= mainMenu.clientWidth - gap * 2 ? 4 : 2;
                grid.style.setProperty('--menu-columns', columns);

                // On phones the grid scrolls, so the strip goes above it.
                discordStrip.classList.toggle('compact', columns === 2);
                if(columns === 2) grid.before(discordStrip);
                else grid.after(discordStrip);
            }


            const allButs = [singleplayerBut, editorBut, characterSelect, discordButton, multiplayerBut];
            allButs.forEach(el => {
                el.addEventListener('mouseenter', () => {
                    const width = el.offsetWidth;
                    const scale = (width + 10) / width;
                    el.style.transform = `scale(${scale})`;
                });
                el.addEventListener('mouseleave', () => {
                    el.style.transform = `scale(1.0)`;
                })
            });

            window.addEventListener('resize', this.gridOnlyEvenCells);

            mainMenu.style.visibility = 'hidden';
            setTimeout(() => {
                this.gridOnlyEvenCells();
                mainMenu.style.visibility = 'visible';
            }, 0);

            customGUIContainer.appendChild(mainMenu);

            if(!singlePlayer){
                this.showSinglePlayer();
                this.hideSinglePlayer();
            }
        }


        const header = mainMenu.querySelector('.header');
        const volumeButton = header.querySelector('.audio');
        if(!Settings.sfxOn) volumeButton.classList.add('disabled');

        volumeButton.onclick = ()=>{
            game.toggleMute();
            if(!Settings.sfxOn){
                volumeButton.classList.add('disabled');
            }else{
                volumeButton.classList.remove('disabled');
            }
        }

        this.setMainMenuCharacterImage();

        mainMenu.style.display = 'block';
        this.setMainMenuActive('main');
        this.gridOnlyEvenCells();

    }

    this.setMainMenuActive = menuName => {
        const mainGrid = mainMenu.querySelector('.menu-grid');
        const browserHolder = mainMenu.querySelector('.multiplayer-browser');
        const lobbyHolder = mainMenu.querySelector('.multiplayer-lobby');

        mainGrid.style.display = menuName === 'main' ? 'grid' : 'none';
        browserHolder.style.display = menuName === 'multiplayer' ? 'block' : 'none'
        lobbyHolder.style.display = menuName === 'lobby' ? 'block' : 'none'

        if(menuName === 'multiplayer'){
            showLobbyBrowser();
        }else{
            hideLobbyBrowser();
        }
        if(menuName === 'lobby'){
            updateLobbyUI();
        }

        mainMenuActive = menuName;
        this.updateDiscordPrompts();

        if (menuName === 'main') {
            mainMenuEntrance.play('.menu-grid');
        } else {
            mainMenuEntrance.cancel();
        }

    }

    this.hideMainMenu = () => {
        mainMenuEntrance?.cancel();
        hideLobbyBrowser();
        if(mainMenu) mainMenu.style.display = "none";
        this.hideCharacterSelect();
        this.hideSettingsMenu();
    }

    this.getFooter = () => {
        const discordLink = `<a href="${discordInviteUrl}" target="_blank" rel="noopener noreferrer" class="jolly-discord" aria-label="Discord" title="Discord"></a>`;
        return /*html*/`
        <footer class="page-footer">
            <div class="footer-meta">
                <div class="rights">© 2026 JollyWorld <span class="version">· v${__VERSION__}</span></div>
                <nav class="footer-links" aria-label="Information">
                    <a href="https://jollyworld.app/privacy-policy/" class="privacy">Privacy</a>
                    <a href="https://jollyworld.app/terms/" class="terms">Terms</a>
                    <a href="mailto:terminarchgames@gmail.com" class="contact">Contact</a>
                </nav>
            </div>
            <div class="social-channels">
                ${discordLink}
                ${Settings.onPoki ? '' : `<a href="https://www.youtube.com/channel/UCmwRcywag6sbOmy0nvsflOw" target="_blank" rel="noopener noreferrer" class="jolly-youtube" aria-label="YouTube" title="YouTube"></a>`}
                ${Settings.onPoki ? '' : `<a href="https://www.facebook.com/jolly.world.game/" target="_blank" rel="noopener noreferrer" class="jolly-facebook" aria-label="Facebook" title="Facebook"></a>`}
                <a href="https://www.poki.com" target="_blank" rel="noopener noreferrer" class="powered-by-poki" aria-label="Powered by Poki" title="Powered by Poki"></a>
            </div>
        </footer>
        `
    }

    this.showSinglePlayer = init =>{
        if(!singlePlayer){
            const htmlStructure = /*html*/`
                <div class="header">
                    <div class="logo"></div>
                    <div class="buttons">
                        <div class="search-filter">
                            <div class="search-icon"></div>
                            <input class="search-input" aria-label="Search levels">
                        </div>
                        <div class="filters-container">
                            <div class="filters">${localize('mainmenu_filters')}</div>
                            <div class="filters-fold">
                                <div>${localize('mainmenu_onlyfeatured')}</div>
                                <label class="feature-toggle switch" data-nav-group-control aria-label="Featured levels only">
                                    <input type="checkbox" checked>
                                    <div class="slider round"></div>
                                </label>
                                <div>${localize('mainmenu_sorted')}</div>
                                <label class="checkbox-container best-rated checked" data-nav-group-control>
                                    <input class="css-checkbox" type="checkbox" checked>${localize('mainmenu_best_rated')}
                                    <i></i>
                                </label>
                                <label class="checkbox-container most-played" data-nav-group-control>
                                    <input class="css-checkbox" type="checkbox" >${localize('mainmenu_most_played')}
                                    <i></i>
                                </label>
                                <label class="checkbox-container newest" data-nav-group-control>
                                    <input class="css-checkbox" type="checkbox">${localize('mainmenu_newest')}
                                    <i></i>
                                </label>
                                <label class="checkbox-container oldest" data-nav-group-control>
                                    <input class="css-checkbox" type="checkbox" >${localize('mainmenu_oldest')}
                                    <i></i>
                                </label>
                                <label class="checkbox-container recently" data-nav-group-control>
                                    <input class="css-checkbox" type="checkbox" >${localize('mainmenu_recently')}
                                    <i></i>
                                </label>
                                <div>${localize('mainmenu_filters')}</div>
                                <div class="date">
                                    <div class="all button checked">${localize('mainmenu_anytime')}</div>
                                    <div class="month button">${localize('mainmenu_thismonth')}</div>
                                    <div class="week button">${localize('mainmenu_thisweek')}</div>
                                    <div class="today button">${localize('mainmenu_today')}</div>
                                </div>
                                <div class="vehicles">
                                    <div class="all button">${localize('mainmenu_allvehicles')}</div>
                                </div>
                            </div>
                        </div>
                        <div class="exit">${localize('editorheader_exit')}</div>
                    </div>
                </div>
                <div class = "games-scroll">
                    <div class="creators"></div>
                    <div class="games">
                        <div class="game-template game">
                            <div class="vehicle-label"></div>
                            <div class="thumb"></div>
                            <div class="footer">
                                <div class="text-holder">
                                    <div class="text-level-name">Level Name Goes Here</div>
                                    <div class="level-author">
                                        <div class="text-level-by">${localize('mainmenu_by')}:</div>
                                        <div class="text-author">Author Name</div>
                                    </div>
                                    <div class="rating">
                                        <div class="bar">
                                            <div class="fill"></div>
                                        </div>
                                        <div class="texts">
                                            <div class="liked">
                                                <div class="like-icon"></div>
                                                <div class="votes">80</div>
                                            </div>
                                            <div class="share">(50%)</div>
                                        </div>
                                    </div>
                                    <div class="tags">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `

            singlePlayer = document.createElement('div');
            singlePlayer.classList.add('singleplayer');
            singlePlayer.innerHTML = htmlStructure;

            if(MobileController.isMobile()){
                singlePlayer.classList.add('mobile');
            }
            if(Settings.onPoki){
                singlePlayer.classList.add('poki');
            }

            const header = singlePlayer.querySelector('.header');

            // FILTERS
            const filterContainer = header.querySelector('.filters-container');

            if(backendManager.isLoggedIn()){
                const bestRatedFilter = filterContainer.querySelector('.best-rated');
                const newestFilter = filterContainer.querySelector('.newest');

                bestRatedFilter.classList.remove('checked');
                bestRatedFilter.querySelector('input').checked = false;
                newestFilter.classList.add('checked');
                newestFilter.querySelector('input').checked = true;
            }

            const reloadFiltered = () => {
                showPromotedLevels = false;
                this.reloadSinglePlayerGames();
            }

            const featureToggle = filterContainer.querySelector('.feature-toggle > input');
            featureToggle.addEventListener('change', reloadFiltered);

            const filterButton = filterContainer.querySelector('.filters');

            const setOpenFilters = bool => {
                filterButton.setAttribute('aria-expanded', String(bool));
                if(bool){
                    filterContainer.classList.add('open');

                    if(this.filterOpenMouseEvent) return;

                    this.filterOpenMouseEvent = event => {
                        let targetElement = event.target;
                        do {
                            if (targetElement == filterContainer) return;
                            targetElement = targetElement.parentNode;
                        } while (targetElement);
                       // close
                       setOpenFilters(false);
                    };
                    document.addEventListener("click", this.filterOpenMouseEvent);
                }else{
                    filterContainer.classList.remove('open');

                    Array.from(filterContainer.querySelectorAll('.open')).forEach(el => {
                        el.classList.remove('open');
                        Array.from(el.children).forEach(child => {
                            if(child.classList.contains('clicked')){
                                child.classList.remove('clicked');
                            }else{
                                child.style.display = 'none';
                            }
                        })
                    });

                    if(this.filterOpenMouseEvent){
                        document.removeEventListener('click', this.filterOpenMouseEvent);
                        delete this.filterOpenMouseEvent;
                    }
                }
            }

            filterButton.addEventListener('click', ()=>{
                setOpenFilters(!filterContainer.classList.contains('open'));
            })
            //

            // SORT
            const checkBoxes =filterContainer.querySelectorAll('.css-checkbox');
            checkBoxes.forEach(checkBox => {
                checkBox.addEventListener('click', () => {
                    if(!checkBox.checked) return;
                    checkBoxes.forEach(cb => cb.checked = false);
                    checkBox.checked = true;
                    reloadFiltered();
                });
            });


            // DATES
            const date = filterContainer.querySelector('.date');
    
            const dateButtons = Array.from(date.querySelectorAll('.button'));
            dateButtons.forEach(button => {
                button.addEventListener('click', () => {
                    if(date.classList.contains('open')){
                        const wasChecked = button.classList.contains('checked');
    
                        dateButtons.forEach(but => {
                            but.style.display = 'none';
                            but.classList.remove('clicked');
                            but.classList.remove('checked');
                        });
                        date.classList.remove('open');
                        button.style.display = 'block';
                        button.classList.add('checked');
                        if(!wasChecked) reloadFiltered();
                    }else{
                        date.classList.add('open');
                        dateButtons.forEach(but => but.style.display = 'block');
                        button.classList.add('clicked');
                    }
                })
            })


            // VEHICLES
            const vehicles = filterContainer.querySelector('.vehicles');
            for(let i = 0; i<=Settings.availableVehicles.length; i++){
                const vehicleFilter = document.createElement('div');
                vehicleFilter.classList.add('button');
                vehicleFilter.setAttribute('title', Settings.availableVehicles[i-1] || 'Any vehicle');
                vehicleFilter.setAttribute('aria-label', Settings.availableVehicles[i-1] || 'Any vehicle');
                vehicles.appendChild(vehicleFilter);
                vehicleFilter.style.display = 'none';
                vehicleFilter.style.width = '48px';

                const vehicleIcon = new Image();
                vehicleIcon.src = `assets/images/portraits/${hashName(`mini-vehicle${i}.png`)}`;
                vehicleFilter.appendChild(vehicleIcon);
            }

            const vehicleButtons = Array.from(vehicles.querySelectorAll('.button'));
            vehicleButtons.forEach(button => {
                button.addEventListener('click', () => {
                    if(vehicles.classList.contains('open')){
                        const wasChecked = button.classList.contains('checked');

                        vehicleButtons.forEach(but => {
                            but.style.display = 'none';
                            but.classList.remove('clicked');
                            but.classList.remove('checked');
                        });
                        vehicles.classList.remove('open');
                        button.style.display = 'block';
                        button.classList.add('checked');
                        if(!wasChecked) reloadFiltered();
                    }else{
                        vehicles.classList.add('open');
                        vehicleButtons.forEach(but => but.style.display = 'block');
                        button.classList.add('clicked');
                    }
                })
            })

            // SEARCH
            const searchInput = header.querySelector('.search-input');

            const sortInputs = Array.from(filterContainer.querySelectorAll('.checkbox-container > input'));
            const shouldSearch = ()=> {
                const search = searchInput.value.trim();
                if(lastSearch === search) return;
                if(search && !lastSearch){
                    sortInputs.forEach(input => input.checked = false);
                }else if(!search && !sortInputs.some(input => input.checked)){
                    filterContainer.querySelector(backendManager.isLoggedIn() ? '.newest > input' : '.best-rated > input').checked = true;
                }
                singlePlayer.classList.toggle('searching', !!search);
                lastSearch = search;
                reloadFiltered();
            }

            searchInput.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    searchInput.blur();
                }
            })

            searchInput.addEventListener('focus', ()=> header.classList.add('search-focussed'));
            searchInput.addEventListener('blur', ()=> {
                header.classList.remove('search-focussed');
                shouldSearch();
            });

            const searchIcon = header.querySelector('.search-icon');
            searchIcon.addEventListener('click', () => shouldSearch())

            // EXIT
            const exitButton = header.querySelector('.exit');
            exitButton.addEventListener('click', () =>{
                if(game.gameState === game.GAMESTATE_MULTIPLAYER_LEVELSELECT){
                    game.openMainMenu();
                    game.gameState = game.GAMESTATE_LOBBY;
                    game.ui.setMainMenuActive('lobby');
                }else{
                    game.openMainMenu();
                }
            });

            if(!MobileController.isMobile()){
                new SimpleBar(singlePlayer.querySelector('.games-scroll'), { autoHide: false, scrollbarMinSize: 100 });
            }

            customGUIContainer.appendChild(singlePlayer);

            // Keep the backdrop in place until the click so a touch cannot reach a level underneath.
            singlePlayer.addEventListener('click', event => {
                if(singlePlayer.classList.contains('inactive')){
                    event.preventDefault();
                    event.stopPropagation();
                    this.hideLevelBanner();
                    this.hideSocialShareMenu();
                    this.hideSettingsMenu();
                    this.hideCharacterSelect();
                    this.hideVehicleSelect();
                    this.hideYouTubePlayer();

                    if(game.gameState !== game.GAMESTATE_MULTIPLAYER_LEVELSELECT){
                        game.gameState = game.GAMESTATE_MENU;
                    }
                }
            }, { capture: true });
        }

        singlePlayer.style.display = 'grid';
        singlePlayer.classList.remove('inactive');

        if(!init) this.reloadSinglePlayerGames();
        admin?.levelList(singlePlayer);
    }

    this.setAdmin = tools => {
        admin = tools;
        if(!admin) return;
        customGUIContainer.querySelectorAll('.game').forEach(tile => {
            if(levelTiles.has(tile)) admin.levelTile(tile, levelTiles.get(tile));
        });
        if(singlePlayer) admin.levelList(singlePlayer);
        if(levelBanner && levelBannerLevel) admin.levelBanner(levelBanner, levelBannerLevel);
        if(userPage && userPageProfile) admin.userPage(userPage, userPageProfile);
    }

    this.makeCountrySelect = country => {
        const flags = country.querySelector('.flags');
        const selectFlag = country.querySelector('.selectflag');

        if(!flags.classList.contains('init')){
            countries.forEach(country=> {
                const flag = document.createElement('div');
                flag.className = `flag fflag fflag-${country.toUpperCase()} ff-lg ff-app`;
                flag.onclick = ()=>{
                    flags.classList.remove('open');

                    selectFlag.className = `flag fflag fflag-${country.toUpperCase()} ff-lg ff-app`;

                    if(Settings.currentCountry !== country){
                        const userData = SaveManager.getLocalUserdata();
                        userData.country = country;
                        SaveManager.updateLocalUserData(userData);
                        window.location.reload();
                    }

                };
                flags.appendChild(flag);
            })
            flags.classList.add('init');
            selectFlag.onclick = ()=>{
                flags.classList.add('open');
                setTimeout(()=>{
                    if(flags) flags.classList.remove('open');
                }, 3000);
            }
        }
        selectFlag.className = `flag fflag fflag-${Settings.currentCountry.toUpperCase()} ff-lg ff-app`;
    }

    this.handleLoginChange = async ()=> {
        const grid = mainMenu.querySelector('.menu-grid');

        // if we can't retrieve userdata quick enough
        if(backendManager.isLoggedIn() && !backendManager.userData){
            setTimeout(this.handleLoginChange, 100);
            return;
        }

        const discordButton = grid.querySelector('.discord-but');
        const discordName = discordButton.querySelector('.profile-name');

        if(backendManager.isLoggedIn()){
            discordName.innerText = backendManager.userData.username;
            discordButton.classList.add('loggedIn');
        }else{
            discordName.innerText = localize('mainmenu_signup');
            discordButton.classList.remove('loggedIn');

        }
        this.updateDiscordPrompts();
    }

    this.updateDiscordPrompts = () => {
        if(mainMenu){
            const standing = backendManager.isLoggedIn() ? backendManager.userData?.discord_level : null;
            const rank = standing ? rankForLevel(standing.level) : null;

            const tile = mainMenu.querySelector('.discord-but');
            tile.classList.toggle('ranked', !!standing);
            tile.classList.toggle('unranked', !!standing && !rank);
            if(standing){
                showRankIcon(tile.querySelector('.profile-rank-icon'), rank || RANKS[0]);
                tile.querySelector('.profile-rank-level').textContent = standing.level;
            }

            const strip = mainMenu.querySelector('.discord-strip');
            const hiddenUntil = SaveManager.getLocalUserdata().discordStripHiddenUntil || 0;
            strip.hidden = !backendManager.needsDiscordJoin() || hiddenUntil > Date.now() || mainMenuActive !== 'main';
            if(!strip.hidden){
                strip.dataset.rank = rank ? rank.id : 'none';
                if(rank) showRankIcon(strip.querySelector('.discord-strip-rank'), rank);
                strip.querySelector('.discord-strip-title').innerHTML = rank
                    ? localize('discord_strip_title', {rank: `<span class="rank-name">${rank.name}</span>`})
                    : localize('discord_getinvolved');
                strip.querySelector('.discord-strip-body').textContent = localize(rank ? 'discord_strip_body' : 'discord_perk_chat');
            }
        }
        if(userPage) this.updateUserPageDiscord();
    }

    let discordJoinListener = null;
    let discordJoinWindow = null;

    const setDiscordJoining = joining => {
        for(const button of document.querySelectorAll('.discord-strip-join, .discordJoin .join, .rank-discord-join')){
            button.disabled = joining;
            const label = button.querySelector('.label');
            if(label) label.textContent = localize(joining ? 'discord_joining' : 'discord_join');
        }
    }

    // The bot gives the role when they join through the invite, so /me knows once they're back.
    const refreshDiscordOnReturn = () => {
        window.addEventListener('focus', () => backendManager.getBackendUserData().catch(() => {}), {once: true});
    }

    this.joinDiscord = () => {
        // Poki only allows outside links through its SDK, which can't hand the code back.
        if(Settings.onPoki){
            openExternalLink(discordInviteUrl);
            refreshDiscordOnReturn();
            return;
        }

        if(discordJoinWindow && !discordJoinWindow.closed){
            discordJoinWindow.focus();
            return;
        }

        const shrink = .8;
        const w = Math.min(Math.floor(window.innerWidth * shrink), 600);
        const h = 800;
        const leftPosition = (window.innerWidth - w) / 2;
        const topPosition = (window.innerHeight - h) / 2;
        const settings = `height=${h},width=${w},top=${topPosition},left=${leftPosition},scrollbars=yes,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no`;

        const url = `${Settings.API}/discord/join?redirect=${encodeURIComponent(Settings.REDIRECT)}`;
        const openedWindow = window.open(url, 'oAuthDiscordJoin', settings);
        if(!openedWindow){
            this.showDiscordJoin('failed');
            return;
        }
        discordJoinWindow = openedWindow;
        setDiscordJoining(true);

        if(discordJoinListener) window.removeEventListener('message', discordJoinListener);
        discordJoinListener = event => {
            if(event.data?.type !== 'discordOauthLogin') return;
            window.removeEventListener('message', discordJoinListener);
            discordJoinListener = null;
            openedWindow.close();

            // Discord sends no code when they cancel.
            if(!event.data.code){
                setDiscordJoining(false);
                return;
            }
            backendManager.joinDiscord(event.data.code)
                .then(() => this.showDiscordJoin('joined'))
                .catch(() => this.showDiscordJoin('failed'))
                .finally(() => setDiscordJoining(false));
        };
        window.addEventListener('message', discordJoinListener);

        // A leftover listener would also take the code of a later login.
        const listener = discordJoinListener;
        const closedCheck = setInterval(() => {
            if(!openedWindow.closed) return;
            clearInterval(closedCheck);
            if(discordJoinListener !== listener) return;
            window.removeEventListener('message', listener);
            discordJoinListener = null;
            setDiscordJoining(false);
        }, 500);
    }

    this.setLevelDataOnGameTile = (game, levelData) => {
        game.dataset.navKey = levelData.id;
        game.setAttribute('aria-label', levelData.title);
        const thumb = game.querySelector('.thumb');
        const thumbSrc = `${Settings.STATIC}/${levelData.thumb_big_md5}.png`;
        thumb.setAttribute('data-src', thumbSrc);

        const title = game.querySelector('.text-level-name');
        title.innerText = levelData.title;
        const author = game.querySelector('.text-author');
        author.innerText = levelData.author.username;

        const vehicleLabel = game.querySelector('.vehicle-label');
        vehicleLabel.style.backgroundImage = `url(assets/images/portraits/${hashName(`mini-vehicle${levelData.forced_vehicle}.png`)})`;

        const rating = game.querySelector('.rating');
        const likeIcon = rating.querySelector('.like-icon');
        const fillColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-bg-color').split('#')[1];
        likeIcon.style.backgroundImage = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 37.6 36.1' style='enable-background:new 0 0 37.6 36.1' xml:space='preserve'%3E%3Cpath d='M2 20c0-.1 0-.1 0 0C.9 19.2.5 18.2.5 17c0-1.8.7-3 2.2-3.5.6-.3 2.3-.5 5.2-.8H12c-.3-.3-.8-1.4-1.7-3.5 0-.1 0-.1-.1-.2-.8-2.2-1.3-3.6-1.3-4.1 0-1 .2-1.9.5-2.6.2-.4.4-.7.6-1 .4-.4.9-.6 1.4-.6 1.3 0 2.5 1 3.4 3 .2.4.4.8.5 1.1.5.7.7 1.1.8 1.2.5.8 1 1.4 1.6 1.7.8.4 1.8.8 3 1.2 1.3.3 2.2.6 2.8.8 2 .6 3.4 1.8 4 3.6-.1-.8.2-1.3.9-1.4.2-.1.9-.1 2-.1 2.3 0 4 1.3 5.2 3.8 1 2 1.5 4.5 1.5 7.4v.2c0 2-.2 3.8-.7 5.4 0 .1-.1.3-.1.4-.7 2.2-1.9 3.3-3.4 3.3-.1.1-.2.1-.3.1h-.9c-.8 0-1.7-.2-2.8-.6l-2.2-1.1c-1 1.5-2.7 2.8-5.1 3.8-1.9.8-3.9 1.2-5.9 1.4-.3 0-.6 0-.9.1h-.1c-.3 0-.8 0-1.3-.1-1.7-.1-3-.3-3.8-.7-.7-.3-1.3-.7-1.7-1.2-.7-.9-.9-1.6-.9-2.5 0-.5 0-1-.1-1.4-.2-1.3-.8-2.1-1.8-2.6-.8-.3-1.3-.6-1.4-.8-.4-.4-.7-1-.7-1.9 0-.1.1-.5.2-1.2v-.2c.1-.8.2-1.2.2-1.4 0-.2 0-.3-.1-.5-.1-.5-.6-1-1.3-1.5' style='fill:%23${fillColor}'/%3E%3Cpath d='M26.6 20.3c-.1-2.3-.4-3.9.6-5.5 4.6 5.2-4.7 18.2 9 13.7-.7 2.4-1.9 3.3-3.6 3.5-1 .1-2.4 0-3.6-.6-.2 0-1.2-.7-2.4-1.1-1.1 1.4-2.6 2.7-5.1 3.7-1.9.8-3.9 1.2-5.8 1.4-4.1.2-9.3-.4-8.5-5.4 4 3.7 12.5 4.1 16.3.1.7-1.2 3.2-8.3 3.1-9.8m-23 1c-.1-.4-.5-.9-1-1.4 2.3.1 2.2 2 1 3.1 0-1 .1-1 0-1.7M9.1 4.7c0-1.2.2-2.3.9-3.3-.1 3.4 1.8 9.5 4.8 11.1l-.1.1h-2.6c-.1-.5-1-1.7-1.7-3.8-.8-2.2-1.3-3.5-1.3-4.1z' style='opacity:.2'/%3E%3Cpath d='M2 19.8s0-.1 0 0C1 19 .5 18 .5 16.8c0-1.8.7-3 2.2-3.5.6-.3 2.3-.5 5.2-.8H12c-.3-.3-.8-1.4-1.7-3.5 0-.1 0-.1-.1-.2-.8-2.1-1.3-3.5-1.3-4.1 0-1 .2-1.9.5-2.6.2-.4.4-.7.6-1 .4-.4.9-.6 1.4-.6 1.3 0 2.5 1 3.4 3 .2.4.4.8.5 1.1.4.7.6 1.2.6 1.3.5.8 1 1.4 1.6 1.7.8.4 1.8.8 3 1.2 1.3.3 2.2.6 2.8.8 2 .6 3.4 1.8 4 3.6-.1-.8.2-1.3.9-1.4.2-.1.9-.1 2-.1 2.3 0 4 1.3 5.2 3.8 1 2 1.5 4.5 1.5 7.4v.2c0 2-.2 3.8-.7 5.4 0 .1-.1.3-.1.4-.7 2.2-1.9 3.3-3.4 3.3-.1.1-.2.1-.3.1h-.9c-.8 0-1.7-.2-2.8-.6l-2.2-1.1c-1 1.5-2.7 2.8-5.1 3.8-1.9.8-3.9 1.2-5.9 1.4-.3 0-.6 0-.9.1h-.1c-.3 0-.8 0-1.3-.1-1.7-.1-3-.3-3.8-.7-.7-.3-1.3-.7-1.7-1.2-.5-.9-.7-1.7-.7-2.6 0-.5 0-1-.1-1.4-.2-1.3-.8-2.1-1.8-2.6-.8-.3-1.3-.6-1.4-.8-.4-.4-.7-1-.7-1.9 0-.1.1-.5.2-1.2v-.2c.1-.8.2-1.2.2-1.4 0-.2 0-.3-.1-.5-.1-.5-.6-1-1.3-1.5' style='fill:none;stroke:%23000;stroke-miterlimit:10'/%3E%3Cpath d='M10.2 27.5c-.3 0-.5-.1-.6-.3-.1-.1-.1-.2-.1-.4 0-.4 1.2-1 3.6-1.9.1 0 .1-.1.2-.1 2.2-.8 3.4-.7 3.4.2 0 .3-.2.6-.6.6-1 .2-1.8.4-2.3.6 0 0-.1 0-.2.1-.2.1-.7.3-1.5.6-1.1.5-1.7.6-1.9.6m5-8.2c-.3 0-1.2.2-2.7.4 0 0-.3.1-.8.2h-.1c-.1 0-.2 0-.3.1-.9.2-1.5.2-1.8.2-.2 0-.4 0-.5-.1-.3-.1-.5-.3-.5-.6s.8-.6 2.4-.9c.4-.1.8-.1 1.2-.2 2.4-.3 3.6-.2 3.6.5-.1.2-.3.3-.5.4z'/%3E%3C/svg%3E")`;

        const sumVotes = levelData.upvotes + levelData.downvotes;
        const votes = rating.querySelector('.votes');
        votes.innerText = "??";

        const share = rating.querySelector('.share');
        share.innerText = '';
        const fill = rating.querySelector('.fill');
        fill.style.width = '0%';

        if(sumVotes>Settings.minlevelVotes){
            votes.innerText = format.formatNumber(sumVotes);
            const voteScore = Math.round((levelData.upvotes / sumVotes) * 100);
            fill.style.width = `${voteScore}%`;
            share.innerText = `${voteScore}%`;
        }

        levelTiles.set(game, levelData);
        admin?.levelTile(game, levelData);

        // const tags = game.querySelector('.tags');
    }

    this.determineSinglePlayerFilter = ()=>{
        const filters = singlePlayer.querySelector('.filters-fold')
        let featured = filters.querySelector('.feature-toggle > input').checked;
        const vehicleFilters = filters.querySelector('.vehicles');

        const search = singlePlayer.querySelector('.search-input').value.trim();

        let sort = '';
        if(filters.querySelector('.most-played > input').checked) sort = this.FILTER_SORT_MOSTPLAYED;
        if(filters.querySelector('.best-rated > input').checked) sort = this.FILTER_SORT_BEST;
        if(filters.querySelector('.newest > input').checked) sort = this.FILTER_SORT_NEWEST;
        if(filters.querySelector('.oldest > input').checked) sort = this.FILTER_SORT_OLDEST;
        if(filters.querySelector('.recently > input').checked) sort = this.FILTER_SORT_RECENTLY;

        let range = '';
        if(filters.querySelector('.all').classList.contains('checked')) range = this.FILTER_RANGE_ANYTIME;
        if(filters.querySelector('.month').classList.contains('checked')) range = this.FILTER_RANGE_THISMONTH;
        if(filters.querySelector('.week').classList.contains('checked')) range = this.FILTER_RANGE_THISWEEK;
        if(filters.querySelector('.today').classList.contains('checked')) range = this.FILTER_RANGE_TODAY;

        let vehicle = '';
        const checkedVehicleFilter = vehicleFilters.querySelector('.checked');
        if(checkedVehicleFilter && !checkedVehicleFilter.classList.contains('all')){
            vehicle = Array.from(vehicleFilters.children).indexOf(checkedVehicleFilter) - 1;
        }

        if(search){
            if(!Settings.onPoki) featured = false;
            range = this.FILTER_RANGE_ANYTIME;
        }

        return {
            search,
            featured,
            sort,
            range,
            vehicle
        }
    }
    this.reloadSinglePlayerGames = ()=>{
        const request = ++singlePlayerRequest;
        const games = singlePlayer.querySelector('.games');

        while(games.children.length>1){
            games.removeChild(games.children[1]);
        }

        const gameTemplate = singlePlayer.querySelector('.game-template');

        const filter = this.determineSinglePlayerFilter();

        const creators = singlePlayer.querySelector('.creators');
        creators.replaceChildren();
        if(filter.search){
            backendManager.searchCreators(filter.search, filter.featured).then(results => {
                if(request !== singlePlayerRequest) return;
                creators.replaceChildren(...results.map(creator => this.createCreatorButton(creator)));
            }).catch(() => {});
        }

        const promotedLevels = showPromotedLevels ? backendManager.getPromotedLevels() : Promise.resolve([]);

        Promise.all([promotedLevels, backendManager.getPublishedLevels(filter)]).then(([promoted, levels]) => {
            if(request !== singlePlayerRequest) return;
            const promotedIds = new Set(promoted.map(level => level.id));
            levels = [...promoted, ...levels.filter(level => !promotedIds.has(level.id))];
            if(initialLevelBatch.length === 0){
                initialLevelBatch = levels;
            }
            levels.forEach( level => {

                const game = gameTemplate.cloneNode(true)
                game.style.display = 'block';
                game.classList.remove('game-template')
                this.setLevelDataOnGameTile(game, level);
                if(promotedIds.has(level.id)){
                    game.classList.add('promoted');
                    const label = document.createElement('div');
                    label.classList.add('promoted-label');
                    label.textContent = localize('mainmenu_promoted');
                    game.appendChild(label);
                }
                games.appendChild(game);

                game.onclick = ()=> this.showLevelBanner(level);

                imageObserver.observe(game);

            })

            while(games.children.length<12){
                games.appendChild(document.createElement('div'))
            }
        }).catch(() => {
            if(request === singlePlayerRequest) backendManager.checkServer();
        })
        gameTemplate.style.display = 'none';
    }
    this.createCreatorButton = creator => {
        const button = document.createElement('button');
        button.type = 'button';
        button.classList.add('creator');

        const name = document.createElement('span');
        name.classList.add('creator-name');
        name.textContent = creator.username;

        const levels = document.createElement('span');
        levels.classList.add('creator-levels');
        levels.textContent = `${localize('userpage_levels')}: ${creator.levels}`;

        button.append(name, levels);
        button.onclick = () => this.showUserPage(creator.username, 'games');
        return button;
    }

    this.showLevelBanner = levelData => {
        if(!levelBanner){
            const htmlStructure = /*html*/`
                <div class="level-info">
                    <div class="thumb"> </div>
                    <div class="text-holder">
                        <div class="level-heading">
                            <div class="text-level-name">Level Name Goes Here</div>
                            <div class="level-author">
                                <div class="text-level-by">${localize('mainmenu_by')}:</div>
                                <div class="text-author">Author Name</div>
                            </div>
                            <div class="tags"></div>
                        </div>
                        <div class="description-holder">
                            <div class="description">Level description goes hereLevel
                            description goes hereLevel description
                            goes hereLevel description goes here
                            Level description goes here</div>
                        </div>
                        <div class="level-published">
                            <div class="published-date">
                                <div class="text-published">Publ.</div>
                                <div class="text-date-published">10. March. 2020</div>
                            </div>
                            <div class="updated-date">
                                <div class="text-updated">Upd.</div>
                                <div class="text-date-updated">10. March. 2020</div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="social-bar${Settings.onPoki ? '' : ' with-comments'}">
                    <div class="share">
                        <div class="share-icon"></div>
                        ${localize('levelbanner_share')}
                    </div>
                    <div class="save">
                        <div class="heart-icon"></div>
                        ${localize('levelbanner_favorite')}
                    </div>
                    ${Settings.onPoki ? '' : /*html*/`
                    <div class="comments">
                        <div class="comments-icon"></div>
                        ${localize('levelbanner_comments')}
                    </div>`}
                    <div class="voting">
                        <div class="vote-down button">
                            <div class="vote-thumb"></div>
                        </div>
                        <div class="vote-up button">
                            <div class="vote-thumb"></div>
                        </div>
                    </div>
                </div>
                <div class="gameinfo-bar">
                    <div class="gameplays">${localize('levelbanner_gameplays')}:<div class="gameplays-text">100000</div></div>
                    <div class="votes">${localize('levelbanner_votes')}:<div class="votes-text">10 (85%)</div></div>
                </div>
                <div class="nav-buttons">
                    <div class="back button">${localize('levelbanner_back')}</div>
                    <div class="play button">
                        <div class="text-play">${localize('levelbanner_play')}</div>
                        <div class="progress"></div>
                    </div>
                </div>
                <div class="leaderboard-bar">
                    <div class="header-bar">
                        <div class="text-header">${localize('levelbanner_leaderboard')}</div>
                        <div class="viewall">${localize('levelbanner_viewall')}</div>
                    </div>
                    <div class="entries offcharts">
                        <div class="entry-info">${localize('levelbanner_loading')}</div>
                        <div class="entry entry-template">
                            <div class="position">
                                <div class="profile"></div>
                                <div class="text-position">1st</div>
                            </div>
                            <div class="text-player-name"><span class="rank-badge"></span><span class="name">Smerik</span></div>
                            <div class="time">
                                <div class="text-time-label">${localize('levelbanner_time')}:</div>
                                <div class="text-time">01:38</div>
                                <div class="text-time-mili">456</div>
                            </div>
                            ${watchReplayHTML()}
                        </div>
                    </div>
                </div>
                <div class="jollyvideo">
                    <div class="jollyvideo-logo"></div>
                    <div class="videos">
                        <div class="video video-template">
                            <div class="play-button"></div>
                        </div>
                    </div>
                </div>
            `;

            levelBanner = document.createElement('div');
            levelBanner.classList.add('levelbanner');
            levelBanner.innerHTML = htmlStructure;

            if(!Settings.disableAds && !Settings.onPoki){
                levelBanner.classList.add('showAds');
            }

            const authorButton = levelBanner.querySelector('.text-author');
            authorButton.onclick = ()=>{
                this.showUserPage(authorButton.innerText, 'games');
            }

            const navButtons = levelBanner.querySelector('.nav-buttons');
            const backButton = navButtons.querySelector('.back');
            backButton.onclick = ()=>{
                if(!Settings.onPoki) history.replaceState({}, 'JollyWorld', '/');
                this.hideLevelBanner();
            }
            customGUIContainer.appendChild(levelBanner);
        }

        this.showAdContainer();

        levelBanner.style.display = 'block';
        singlePlayer.classList.add('inactive');

        const navButtons = levelBanner.querySelector('.nav-buttons');
        const playButton = navButtons.querySelector('.play');
        const playButtonText = playButton.querySelector('.text-play');


        if(game.gameState === game.GAMESTATE_MULTIPLAYER_LEVELSELECT){
            playButtonText.innerText = localize('levelbanner_select');
            playButton.onclick = () => {
                selectMultiplayerLevel(levelData);

                game.openMainMenu();
                game.gameState = game.GAMESTATE_LOBBY;
                game.ui.setMainMenuActive('lobby');
            }
        }else{
            playButtonText.innerText = localize('levelbanner_play');
            const playLevelFunction = () => {
                if (game.gameState != game.GAMESTATE_MENU) return;
                game.gameState = game.GAMESTATE_LOADINGDATA;

                playButton.classList.add('loading');

                playButtonText.innerText = 'Loading';

                const progressBar = playButton.querySelector('.progress');
                const progressFunction = progress => {
                    progress = Math.max(0, Math.min(1, progress));
                    const progressRounded = (progress*100).toFixed(2);
                    progressBar.style.width = `${progressRounded}%`;
                }

                const finishLoading = ()=>{
                    playButton.classList.remove('loading');
                    playButtonText.innerText = localize('levelbanner_play');
                }

                saveRecentlyPlayed(levelData);

                game.loadPublishedLevelData(levelData, progressFunction).then(() => {
                    this.hideLevelBanner();
                    if(levelData.forced_vehicle){
                        game.selectedVehicle = levelData.forced_vehicle;
                        this.playLevelFromSinglePlayer();
                    }else{
                        this.showVehicleSelect();
                    }
                    finishLoading();
                }).catch(error => {
                    finishLoading();
                });
            }
            playButton.onclick = playLevelFunction;
        }

        const socialBar = levelBanner.querySelector('.social-bar');
        const shareButton = socialBar.querySelector('.share')

        shareButton.onclick = () => this.showSocialShare(levelData);

        const commentsButton = socialBar.querySelector('.comments');
        if(commentsButton) commentsButton.onclick = () => this.showLevelComments(levelData);

        document.title = 'JollyWorld - '+levelData.title;
        if(!Settings.onPoki) history.replaceState({}, document.title, `?lvl=${levelData.id}`);
        else PokiSDK.shareableURL({lvl:levelData.id}).catch(err=>{});

        const voteButtons = levelBanner.querySelector('.voting');
        const voteUpButton = voteButtons.querySelector('.vote-up');
        const voteDownButton = voteButtons.querySelector('.vote-down');

        shouldShowVoteButton(voteUpButton, voteDownButton, levelData);


        const heartButton = socialBar.querySelector('.save');
        this.enableHeartButton(heartButton, levelData);

        const leaderboardBar = levelBanner.querySelector('.leaderboard-bar');

        const showAllButton = leaderboardBar.querySelector('.viewall')
        showAllButton.onclick = ()=> this.showLeaderboard(levelData);

        this.fillLeaderboard(leaderboardBar, levelData.id, 3);

        this.enableVoteButtons(voteUpButton, voteDownButton, levelData);

        this.setLevelBannerData(levelData);
        levelBanner.scrollTop = 0;

        levelBannerLevel = levelData;
        admin?.levelBanner(levelBanner, levelData);
    }

    this.showAdContainer = () => {
        if(!adContainer){
            adContainer = getAdContainer();
            customGUIContainer.appendChild(adContainer);
        }

        adContainer.style.display = 'block';
        adContainer.classList.add('active');
        updateDisplayAds();

    }

    this.hideAdContainer = () => {
        if(adContainer){
            adContainer.style.display = 'none';
            adContainer.classList.remove('active');

            destroyAllAds();
        }
    }

    this.showUserPage = (username, defaultChecked) => {
        if(!userPage){
            const htmlStructure = /*html*/`
                <div class="header">
                    <div class="userinfo">
                        <div class="username"></div>
                        <div class="membersince"><span>${localize('userpage_membersince')}:</span><span class="value">?</span></div>
                    </div>
                    <div class="nav-buttons">
                        <button type="button" class="logout button">${localize('editorheader_logout')}</button>
                        <button type="button" class="back button">${localize('levelbanner_back')}</button>
                    </div>
                    <div class="rank-card" hidden>
                        <div class="rank-fx" aria-hidden="true"></div>
                        <div class="rank-icon" role="img"></div>
                        <div class="rank-info">
                            <div class="rank-title">
                                <span class="rank-name"></span>
                                <span class="rank-level"></span>
                                <span class="rank-position"></span>
                            </div>
                            <div class="rank-bar"><div class="rank-fill"></div></div>
                            <div class="rank-meta">
                                <span class="rank-xp"></span>
                                <span class="rank-next">
                                    <span class="label">${localize('rank_next')}</span>
                                    <span class="icon"></span>
                                    <span class="name"></span>
                                    <span class="level"></span>
                                </span>
                            </div>
                        </div>
                        <div class="rank-discord" hidden>
                            <span class="discord-glyph" aria-hidden="true"></span>
                            <div class="rank-discord-text">
                                <span class="title"></span>
                                <span class="body"></span>
                            </div>
                            <button type="button" class="rank-discord-join"><span class="label">${localize('discord_join')}</span></button>
                            <button type="button" class="rank-discord-open">${localize('discord_open')}</button>
                        </div>
                    </div>
                </div>
                <div class="flair">
                    <div class="gamespublished"><span>${localize('userpage_levelspublished')}</span><span class="value">?</span></div>
                    <div class="gamesaveragerating"><span>${localize('userpage_averagerating')}</span><span class="value">?</span></div>
                    <div class="gamesfeatured"><span>${localize('userpage_levelsfeatured')}</span><span class="value">?</span></div>
                    <div class="gamestotalgameplays"><span>${localize('userpage_totalgameplays')}</span><span class="value">?</span></div>
                </div>
                <div class="titlebar">
                    <div class="togglebuttons">
                        <button type="button" class="games checked" aria-pressed="true">${localize('userpage_levels')}</button>
                        <button type="button" class="favorites" aria-pressed="false">${localize('userpage_favorites')}</button>
                    </div>
                </div>
                <div class = "games-scroll">
                    <div class="profile-status" role="status"></div>
                    <div class="gamesholder">
                    </div>
                </div>
            `;

            userPage = document.createElement('div');
            userPage.classList.add('userPage');
            userPage.innerHTML = htmlStructure;

            userPage.querySelector('.rank-discord-join').onclick = () => this.joinDiscord();
            userPage.querySelector('.rank-discord-open').onclick = () => openExternalLink(discordServerUrl);

            const navButtons = userPage.querySelector('.nav-buttons');
            const backButton = navButtons.querySelector('.back');
            backButton.onclick = ()=>{
                if(!Settings.onPoki) history.replaceState({}, 'JollyWorld', '/');
                this.hideUserPage();
            }

            const logoutButton = navButtons.querySelector('.logout');
            logoutButton.onclick = ()=>{
                backendManager.backendSignout();
                logoutButton.style.display = 'none';
            }

            customGUIContainer.appendChild(userPage);
        }


        const toggleButtons = userPage.querySelector('.togglebuttons');
        const games = toggleButtons.querySelector('.games');
        const favorites = toggleButtons.querySelector('.favorites');

        games.onclick = ()=>{
            if(!games.classList.contains('checked')){
                games.classList.add('checked');
                favorites.classList.remove('checked');
                this.showUserPage(username);
            }
        }

        favorites.onclick = ()=>{
            if(!favorites.classList.contains('checked')){
                favorites.classList.add('checked');
                games.classList.remove('checked');
                this.showUserPage(username);
            }
        }

        if(defaultChecked === 'games'){
            favorites.classList.remove('checked');
            games.classList.add('checked');
        } else if(defaultChecked === 'favorite'){
            favorites.classList.add('checked');
            games.classList.remove('checked');
        }

        games.setAttribute('aria-pressed', games.classList.contains('checked'));
        favorites.setAttribute('aria-pressed', favorites.classList.contains('checked'));
        this.setUserPageInfo(username);

        if(!Settings.onPoki) history.replaceState({}, document.title, `?user=${encodeURIComponent(username)}`);

        userPage.parentNode.appendChild(userPage);

        userPage.style.display = 'grid';
        userPage.scrollTop = 0;
    }

    this.setUserPageInfo = async username => {
        const request = ++userPageRequest;

        const header = userPage.querySelector('.header');
        const username_text = header.querySelector('.username');
        const membersince_text = header.querySelector('.membersince  > .value');

        const flair = userPage.querySelector('.flair');
        const gamespublished = flair.querySelector('.gamespublished > .value');
        const gamesaveragerating = flair.querySelector('.gamesaveragerating > .value');
        const gamesfeatured = flair.querySelector('.gamesfeatured > .value');
        const gamestotalgameplays = flair.querySelector('.gamestotalgameplays > .value');

        if(username_text.innerText !== username){
            this.setUserPageRank(null);
            membersince_text.innerText = "?";
            gamespublished.innerText = "?";
            gamesaveragerating.innerText = "?";
            gamesfeatured.innerText = "?";
            gamestotalgameplays.innerText = "?";
        }
        username_text.innerText = username;
        const logoutButton = userPage.querySelector('.logout');
        logoutButton.style.display = backendManager.isLoggedIn() && backendManager.userData?.username === username ? 'block' : 'none';
        const gamesHolder = userPage.querySelector('.gamesholder');
        const status = userPage.querySelector('.profile-status');
        status.hidden = false;
        status.innerText = localize('levelbanner_loading');
        userPage.querySelector('.games-scroll').scrollTop = 0;

        while(gamesHolder.children.length>0){
            imageObserver.unobserve(gamesHolder.children[0]);
            gamesHolder.removeChild(gamesHolder.children[0]);
        }

        userPageProfile = null;
        admin?.userPage(userPage, null);

        let userData;
        try{
            userData = await backendManager.getUserProfile(username);
        }catch(error){
            if(request === userPageRequest) status.innerText = localize('userpage_loaderror');
            return;
        }
        if(request !== userPageRequest) return;

        if(userData){
            userPageProfile = userData;
            admin?.userPage(userPage, userData);
            username_text.innerText = username;
            membersince_text.innerText = format.formatDMY(userData.created_at);
            gamespublished.innerText = userData.published_levels.length;
            this.setUserPageRank(userData.discord_level);

            const logoutButton = userPage.querySelector('.logout');
            if(!backendManager.isLoggedIn() || (!backendManager.userData || backendManager.userData.username !== username)){
                logoutButton.style.display = 'none';
            }else{
                logoutButton.style.display = 'block';
            }


            if(userData.published_levels.length > 0){

                let upvotes = 0;
                let downvotes = 0;

                userData.published_levels.forEach( level => {
                    upvotes += level.upvotes;
                    downvotes += level.downvotes;
                })

                const totalVotes = upvotes + downvotes;
                gamesaveragerating.innerText = totalVotes ? `${Math.round(upvotes / totalVotes * 100)}%` : '—';
                gamesfeatured.innerText = userData.published_levels.filter(level => level.featured).length;
                const totalGameplays = userData.published_levels.reduce((a, b) => a + b.playcount, 0);
                gamestotalgameplays.innerText = format.formatNumber(totalGameplays);
                gamestotalgameplays.title = totalGameplays.toLocaleString();
            }else{
                gamesaveragerating.innerText = "-";
                gamesfeatured.innerText = "-";
                gamestotalgameplays.innerText = "-";
            }

            const toggleButtons = userPage.querySelector('.togglebuttons');
            const gamesChecked = toggleButtons.querySelector('.games');

            const gameTemplate = singlePlayer.querySelector('.game-template');
            const targetGames = gamesChecked.classList.contains('checked') ? userData.published_levels : userData.favorite_levels;
            status.hidden = targetGames.length > 0;
            status.innerText = localize(gamesChecked.classList.contains('checked') ? 'userpage_nolevels' : 'userpage_nofavorites');

            targetGames.forEach( level => {
                const game = gameTemplate.cloneNode(true)
                game.style.display = 'block';
                game.classList.remove('game-template')
                this.setLevelDataOnGameTile(game, level);
                gamesHolder.appendChild(game);
                game.onclick = ()=> {
                    this.hideUserPage();
                    this.showLevelBanner(level);
                }
                imageObserver.observe(game);
            });

        }else{
            status.innerText = localize('userpage_notfound');
        }

    }

    this.updateUserPageDiscord = () => {
        const row = userPage.querySelector('.rank-discord');
        const rank = RANKS.find(rank => rank.id === userPage.dataset.rank);
        const inGuild = backendManager.userData?.in_guild;
        const own = backendManager.isLoggedIn() && backendManager.userData?.username === userPage.querySelector('.header .username').innerText;

        row.hidden = !own || !rank || typeof inGuild !== 'boolean';
        if(row.hidden) return;

        row.classList.toggle('member', inGuild);
        row.querySelector('.title').textContent = localize(inGuild ? 'discord_profile_member' : 'discord_profile_title', {rank: rank.name});
        row.querySelector('.body').textContent = inGuild ? '' : localize('discord_profile_body', {rank: rank.name});
    }

    this.setUserPageRank = standing => {
        const card = userPage.querySelector('.rank-card');
        const rank = standing ? rankForLevel(standing.level) : null;
        userPage.dataset.rank = rank ? rank.id : '';
        card.hidden = !standing;
        this.updateUserPageDiscord();
        if(!standing) return;

        card.dataset.rank = rank ? rank.id : 'none';
        const icon = card.querySelector('.rank-icon');
        showRankIcon(icon, rank || RANKS[0]);
        icon.setAttribute('aria-label', rank ? rank.name : localize('rank_unranked'));
        card.querySelector('.rank-name').innerText = rank ? rank.name : localize('rank_unranked');
        card.querySelector('.rank-level').innerText = localize('rank_level', {level: standing.level});
        const position = card.querySelector('.rank-position');
        position.hidden = !standing.rank;
        position.innerText = localize('rank_position', {rank: standing.rank.toLocaleString(), total: standing.ranked.toLocaleString()});
        card.querySelector('.rank-xp').innerText = `${standing.level_xp.toLocaleString()} / ${standing.level_xp_needed.toLocaleString()} XP`;

        const next = nextRank(standing.level);
        const nextInfo = card.querySelector('.rank-next');
        const nextIcon = nextInfo.querySelector('.icon');
        nextInfo.querySelector('.label').hidden = !next;
        nextIcon.hidden = !next;
        if(next) showRankIcon(nextIcon, next);
        nextInfo.querySelector('.name').innerText = next ? next.name : localize('rank_max');
        nextInfo.querySelector('.level').innerText = next ? localize('rank_level', {level: next.level}) : '';

        const fill = card.querySelector('.rank-fill');
        fill.style.transform = 'scaleX(0)';
        void fill.offsetWidth;
        fill.style.transform = `scaleX(${standing.level_xp / standing.level_xp_needed})`;

        const fx = card.querySelector('.rank-fx');
        fx.replaceChildren();
        const sparks = {ruby: 10, diamond: 14, dragon: 18}[rank?.id] || 0;
        for(let i = 0; i < sparks; i++){
            const spark = document.createElement('i');
            spark.style.setProperty('--x', `${Math.random() * 100}%`);
            spark.style.setProperty('--y', `${Math.random() * 100}%`);
            spark.style.setProperty('--size', `${4 + Math.random() * 6}px`);
            spark.style.setProperty('--drift', `${Math.random() * 40 - 20}px`);
            spark.style.animationDuration = `${2 + Math.random() * 2.5}s`;
            spark.style.animationDelay = `${-Math.random() * 4.5}s`;
            fx.appendChild(spark);
        }
    }

    this.hideUserPage = ()=>{
        userPageRequest++;
        userPage.style.display = 'none';
    }

    const watchReplayHTML = () => /*html*/`
        <div class="watch-replay" title="${localize('replay_watch')}">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/></svg>
        </div>
    `;
    const watchLeaderboardReplay = id => {
        if(leaderboard) this.hideLeaderboard();
        game.openReplayLink(id);
    };

    this.fillLeaderboard = async (element, levelid, limit) => {

        const entries = element.querySelector('.entries');
        const template = entries.querySelector('.entry-template');
        template.style.display = 'none';

        const info = entries.querySelector('.entry-info');
        info.innerText = 'Loading...';
        info.style.display = 'block';

        while(entries.children.length>2){
            entries.removeChild(entries.children[2]);
        }

        const promises = [backendManager.getLeaderboardPosition(levelid), backendManager.getLeaderboard(levelid, limit)];
        let [myPosition, leaderboardData] = await Promise.all(promises);
        myPosition = Array.isArray(myPosition) ? myPosition[0] : myPosition;
    
        if(backendManager.isLoggedIn() && !backendManager.userData){
            // if we have not yet retreived the userdata fetch it
            await backendManager.getBackendUserData();
        }

        const inRankings = backendManager.isLoggedIn() && leaderboardData.find(entry => entry.username === backendManager.userData.username);

        entries.classList.remove('offcharts', 'has-replays');
        let offcharts = false;
        if(!inRankings && myPosition && myPosition.time !== 0){
            myPosition.username = backendManager.userData.username;
            leaderboardData[limit-1] = myPosition;
            entries.classList.add('offcharts');
            offcharts = true;
        }

        if(!leaderboardData || leaderboardData.length == 0){
            info.innerText = localize('levelbanner_noentries');
        }else{
            info.style.display = 'none';
            entries.classList.toggle('has-replays', leaderboardData.some(entryData => entryData.replay_id));

            leaderboardData.forEach( (entryData, i) => {
                const entry = template.cloneNode(true);
                entry.style.display = 'flex';
                entry.classList.remove('entry-template');
                entry.classList.add('entry');

                const position = entry.querySelector('.text-position');

                if(i<(limit-1) || !offcharts){
                    position.innerText = format.makeOrdinal(i+1);
                }else{
                    position.innerText = entryData.position ? format.makeOrdinal(entryData.position) : '??';
                }

                const username = entry.querySelector('.text-player-name')
                username.querySelector('.name').innerText = entryData.username;

                username.onclick = ()=>{
                    this.showUserPage(entryData.username, 'games');
                }

                const rank = rankForLevel(entryData.discord_level || 0);
                const rankBadge = username.querySelector('.rank-badge');
                entry.dataset.rank = rank ? rank.id : 'none';
                showRankIcon(rankBadge, rank || RANKS[0]);
                rankBadge.title = rank ? `${rank.name} · ${localize('rank_level', {level: entryData.discord_level})}` : localize('rank_unranked');

                if(backendManager.isLoggedIn() && entryData.username === backendManager.userData.username){
                    entry.classList.add('me');
                }

                const d = format.timeFormat(entryData.time);
                const s = d.hh !== '00' ? `${d.hh}:${d.mm}:${d.ss}.` : `${d.mm}:${d.ss}.`;

                const timeText = entry.querySelector('.text-time');
                timeText.innerText = s;

                const timeTextMili = entry.querySelector('.text-time-mili');
                timeTextMili.innerText = d.ms;

                if(entryData.replay_id){
                    const watch = entry.querySelector('.watch-replay');
                    watch.classList.add('available');
                    watch.onclick = () => watchLeaderboardReplay(entryData.replay_id);
                }

                const profile = entry.querySelector('.profile');

                getModdedPortrait(`profile${entryData.character+1}.png`, 'assets/images/portraits/').then(url => {
                    if(profile) profile.style.backgroundImage = `url(${url})`;;
                });

                entries.appendChild(entry);
            })

        }
    }

    this.showLeaderboard = levelData => {
        if(!leaderboard){
            const htmlStructure = /*html*/`
                <div class="header">${localize('levelbanner_leaderboard')}</div>
                <div class="leaderboard-bar">
                    <div class="entries offcharts">
                        <div class="entry-info">${localize('levelbanner_loading')}</div>
                        <div class="entry entry-template">
                            <div class="position">
                                <div class="profile"></div>
                                <div class="text-position">1st</div>
                            </div>
                            <div class="text-player-name"><span class="rank-badge"></span><span class="name">Smerik</span></div>
                            <div class="time">
                                <div class="text-time-label">${localize('levelbanner_time')}:</div>
                                <div class="text-time">01:38</div>
                                <div class="text-time-mili">456</div>
                            </div>
                            ${watchReplayHTML()}
                        </div>
                    </div>
                </div>
                <div class="nav-buttons">
                    <div class="back button">${localize('levelbanner_back')}</div>
                </div>
            `;

            leaderboard = document.createElement('div');
            leaderboard.classList.add('leaderboard');
            leaderboard.innerHTML = htmlStructure;

            const navButtons = leaderboard.querySelector('.nav-buttons');
            const backButton = navButtons.querySelector('.back');
            backButton.onclick = ()=>{
                this.hideLeaderboard();
            }
            customGUIContainer.appendChild(leaderboard);
        }

        leaderboard.style.display = 'block';

        const leaderboardBar = leaderboard.querySelector('.leaderboard-bar');
        this.fillLeaderboard(leaderboardBar, levelData.id, 100);
    }

    this.hideLeaderboard = ()=>{
        leaderboard.style.display = 'none';
    }

    this.showLevelComments = levelData => {
        if(!levelComments){
            const htmlStructure = /*html*/`
                <div class="header">${localize('levelbanner_comments')}</div>
                <div class="comment-form">
                    <textarea class="comment-input" maxlength="300" placeholder="${localize('comments_placeholder')}"></textarea>
                    <div class="comment-form-footer">
                        <div class="comment-count"></div>
                        <div class="comment-error"></div>
                        <div class="post button">${localize('comments_post')}</div>
                    </div>
                </div>
                <div class="comment-login button">${localize('comments_login')}</div>
                <div class="comment-list"></div>
                <div class="comment-info"></div>
                <div class="nav-buttons">
                    <div class="more button">${localize('comments_loadmore')}</div>
                    <div class="back button">${localize('levelbanner_back')}</div>
                </div>
            `;

            levelComments = document.createElement('div');
            levelComments.classList.add('levelcomments');
            levelComments.innerHTML = htmlStructure;
            levelComments.querySelector('.back').onclick = () => this.hideLevelComments();
            levelComments.querySelector('.comment-login').onclick = () => game.ui.showLoginPrompt();
            backendManager.registerListener('login', () => {
                if(levelComments.style.display !== 'none') this.showLevelComments(levelCommentsLevel);
            });
            customGUIContainer.appendChild(levelComments);
        }

        levelComments.style.display = 'block';
        levelCommentsLevel = levelData;

        const form = levelComments.querySelector('.comment-form');
        const input = form.querySelector('.comment-input');
        const count = form.querySelector('.comment-count');
        const error = form.querySelector('.comment-error');
        const postButton = form.querySelector('.post');
        const loginButton = levelComments.querySelector('.comment-login');
        const list = levelComments.querySelector('.comment-list');
        const info = levelComments.querySelector('.comment-info');
        const moreButton = levelComments.querySelector('.more');

        const loggedIn = backendManager.isLoggedIn();
        form.style.display = loggedIn ? '' : 'none';
        loginButton.style.display = loggedIn ? 'none' : '';

        // Responses for a popup the player already closed are ignored.
        const levelId = levelData.id;
        const view = ++levelCommentsView;
        const isCurrent = () => view === levelCommentsView && levelComments.style.display !== 'none';

        const shown = new Set();
        let page = 0;
        let pages = 0;

        const updateInfo = () => {
            info.innerText = shown.size ? '' : localize('comments_empty');
            moreButton.style.display = page < pages ? '' : 'none';
        }

        const renderComment = comment => {
            shown.add(comment.id);

            const entry = document.createElement('div');
            entry.classList.add('comment');

            const header = document.createElement('div');
            header.classList.add('comment-header');

            const user = document.createElement('div');
            user.classList.add('comment-user');
            user.textContent = comment.username;
            header.appendChild(user);

            const date = document.createElement('div');
            date.classList.add('comment-date');
            date.textContent = format.formatDMY(comment.created_at);
            header.appendChild(date);

            if(comment.can_delete){
                const deleteButton = document.createElement('div');
                deleteButton.classList.add('comment-delete');
                deleteButton.textContent = localize('comments_delete');
                deleteButton.onclick = () => {
                    if(!deleteButton.classList.contains('confirm')){
                        deleteButton.classList.add('confirm');
                        deleteButton.textContent = localize('comments_deletesure');
                        return;
                    }
                    backendManager.deleteLevelComment(comment.id).then(() => {
                        if(!isCurrent()) return;
                        shown.delete(comment.id);
                        entry.remove();
                        updateInfo();
                    }).catch(() => {
                        deleteButton.textContent = localize('comments_error');
                    });
                }
                header.appendChild(deleteButton);
            }

            const text = document.createElement('div');
            text.classList.add('comment-text');
            text.textContent = comment.text;

            entry.appendChild(header);
            entry.appendChild(text);
            return entry;
        }

        const loadPage = () => {
            moreButton.style.display = 'none';
            info.innerText = localize('levelbanner_loading');
            backendManager.getLevelComments(levelId, page + 1).then(result => {
                if(!isCurrent()) return;
                page = result.page;
                pages = result.pages;
                result.comments.forEach(comment => {
                    if(!shown.has(comment.id)) list.appendChild(renderComment(comment));
                });
                updateInfo();
            }).catch(() => {
                if(isCurrent()) info.innerText = localize('comments_error');
            });
        }

        const updateCount = () => count.innerText = `${input.value.length}/300`;

        const post = () => {
            const text = input.value.trim();
            if(!text || postButton.classList.contains('loading')) return;
            postButton.classList.add('loading');
            error.innerText = '';
            backendManager.postLevelComment(levelId, text).then(comment => {
                if(!isCurrent()) return;
                input.value = '';
                updateCount();
                list.insertBefore(renderComment(comment), list.firstChild);
                list.scrollTop = 0;
                updateInfo();
            }).catch(err => {
                if(isCurrent()) error.innerText = localize(err === 'commenting too fast' ? 'comments_toofast' : 'comments_error');
            }).finally(() => {
                postButton.classList.remove('loading');
            });
        }

        input.value = '';
        error.innerText = '';
        input.oninput = updateCount;
        input.onkeydown = event => {
            if(event.key === 'Enter' && !event.shiftKey){
                event.preventDefault();
                post();
            }
        }
        postButton.onclick = post;
        moreButton.onclick = loadPage;
        list.innerHTML = '';
        list.scrollTop = 0;
        updateCount();
        loadPage();
    }

    this.hideLevelComments = ()=>{
        levelComments.style.display = 'none';
    }

    this.enableVoteButtons = (voteUpButton, voteDownButton, levelData) => {
        [voteUpButton, voteDownButton].forEach(button => {
            const thumb = button.querySelector('.vote-thumb');
            thumb.classList.remove('voted')

            button.onclick = ()=>{
                const vote = button === voteUpButton ? 1 : -1;
                const previousVote = BackendCache.voteDataCache[levelData.id];
                game.voteLevel(levelData, vote).then(()=>{
                    thumb.classList.remove('voted')
                    void thumb.offsetWidth;
                    thumb.classList.add('voted')
                    shouldShowVoteButton(voteUpButton, voteDownButton, levelData);
                    if(previousVote !== vote) this.countVote(levelData, previousVote, vote);
                }).catch(err=>{
                    // error
                    console.log(err);
                });

            }
        })
    }

    // The backend doesn't send the new totals back, so the vote is counted here.
    this.countVote = (levelData, previousVote, vote) => {
        const upvotes = (vote > 0) - (previousVote > 0);
        const downvotes = (vote < 0) - (previousVote < 0);
        const tiles = [...customGUIContainer.querySelectorAll(`.game[data-nav-key="${CSS.escape(levelData.id)}"]`)];
        const bannerLevel = levelBannerLevel?.id === levelData.id ? levelBannerLevel : null;
        const levels = new Set([levelData, bannerLevel, ...tiles.map(tile => levelTiles.get(tile))]);
        levels.forEach(level => {
            if(!level) return;
            level.upvotes += upvotes;
            level.downvotes += downvotes;
        });
        tiles.forEach(tile => this.setLevelDataOnGameTile(tile, levelTiles.get(tile)));
        if(bannerLevel) this.setLevelBannerVotes(bannerLevel);
    }

    this.enableHeartButton = (heart, levelData) => {

        heart.onclick = ()=>{

            if(!backendManager.isLoggedIn()){
                game.ui.showLoginPrompt();
                return;
            }

            if(heart.classList.contains('disabled')){
                heart.classList.remove('faved')
                void heart.offsetWidth;
                heart.classList.add('faved')
                backendManager.favoriteLevel(levelData.id);
                heart.classList.remove('disabled');
            }else{
                backendManager.unfavoriteLevel(levelData.id);
                heart.classList.add('disabled');
            }
        }

        shouldShowHeartButton(heart, levelData);
    }

    this.setLevelBannerVotes = levelData => {
        const sumVotes = levelData.upvotes + levelData.downvotes;
        const rating = levelData.upvotes / sumVotes;

        const votes = levelBanner.querySelector('.gameinfo-bar .votes-text');

        if(levelData.upvotes + levelData.downvotes > 0){
            votes.innerText = `${sumVotes} (${Math.round(rating * 100)}%)`;
        } else{
            votes.innerText = `${sumVotes}`;
        }
    }

    this.setLevelBannerData = levelData => {
        console.log('levelData:', levelData)

        const thumb = levelBanner.querySelector('.thumb');
        const thumbSrc = `${Settings.STATIC}/${levelData.thumb_big_md5}.png`;
        thumb.style.backgroundImage = `url(${thumbSrc})`;


        const title = levelBanner.querySelector('.text-level-name');
        title.innerText = levelData.title;
        const author = levelBanner.querySelector('.text-author');
        author.innerText = levelData.author.username;

        const description = levelBanner.querySelector('.description');
        description.innerText = levelData.description;


        const publishedDateDiv = levelBanner.querySelector('.level-published');

        const publishedDate = publishedDateDiv.querySelector('.text-date-published');
        publishedDate.innerText = format.formatDMY(levelData.created_at);

        if(format.formatDMY(levelData.updated_at) === publishedDate.innerText){
            publishedDateDiv.classList.add('no-update');
        }else{
            publishedDateDiv.classList.remove('no-update');
            const updatedDate = publishedDateDiv.querySelector('.text-date-updated');
            updatedDate.innerText = format.formatDMY(levelData.updated_at);
        }

        // game info

        const gameInfoBar = levelBanner.querySelector('.gameinfo-bar');
        const gameplays = gameInfoBar.querySelector('.gameplays-text');
        gameplays.innerText = format.formatNumber(levelData.playcount);

        this.setLevelBannerVotes(levelData);

        // jolly video
        const jollyVideoHolder = levelBanner.querySelector('.jollyvideo');

        if(!Settings.onPoki && levelData.youtubelinks && levelData.youtubelinks.length > 0){
            jollyVideoHolder.style.display = 'block';
            const videosDiv = jollyVideoHolder.querySelector('.videos');

            while(videosDiv.children.length>1){
                videosDiv.removeChild(videosDiv.children[1]);
            }

            const videoTemplate = videosDiv.querySelector('.video-template')
            videoTemplate.style.display = 'none';
            levelData.youtubelinks.forEach(ytId => {
                const video = videoTemplate.cloneNode(true)
                video.style.display = 'block';
                video.classList.remove('video-template')
                video.style.backgroundImage = `url(https://i.ytimg.com/vi/${ytId}/mqdefault.jpg)`;

                const playBut = video.querySelector('.play-button');
                playBut.innerHTML = YouTubePlayer.playButtonHTML;

                video.onclick = () => {
                    this.showYouTubePlayer(ytId);
                }

                videosDiv.appendChild(video);
            })
        }else{
            jollyVideoHolder.style.display = 'none';
        }
    }
    this.hideLevelBanner = ()=>{
        if(levelBanner){
            const thumb = levelBanner.querySelector('.thumb');
            thumb.style.backgroundImage = 'none';

            levelBanner.style.display = 'none';
            singlePlayer.classList.remove('inactive');

            this.hideAdContainer();
        }
        if(levelComments) this.hideLevelComments();
    }

    this.showLoginPrompt = ()=> {
        const container = document.querySelector('#settings-ui');
        if(!loginScreen){
            const htmlStructure = /*html*/`
                <div class="bar"></div>
                <div class="header">Please login</div>
                <div class="body"> Features like voting and cloud saving of levels require you to login. You can login using Discord via the button below. </div>
                <div class="nav-buttons">
                    <div class="back">Back</div>
                    <div class="discord">Login</div>
                </div>
                <div class="powered-by">
                    Login is powered by
                    <div class="discord-logo">
                </div>
            `;

            loginScreen = document.createElement('div');
            loginScreen.classList.add('loginscreen');
            loginScreen.innerHTML = htmlStructure;


            const navButtons = loginScreen.querySelector('.nav-buttons');
            const backButton = navButtons.querySelector('.back');
            backButton.onclick = ()=>{
                loginScreen.style.display = 'none';
            }

            const loginButton = navButtons.querySelector('.discord');
            loginButton.onclick = ()=>{
                loginScreen.style.display = 'none';
                this.openDiscordOauth();
            }

            container.appendChild(loginScreen);
        }

        loginScreen.style.display = 'block';
    }

    this.openDiscordOauth = function(){
        const shrink = .8;
        const w = Math.min(Math.floor(window.innerWidth * shrink), 600);
        const h = 800;
        const leftPosition = (window.innerWidth - w) / 2;
        const topPosition = (window.innerHeight - h) / 2;
        const settings = `height=${h},width=${w},top=${topPosition},left=${leftPosition},scrollbars=yes,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no`;

        const url = `https://api.jollyworld.app/login?redirect=${encodeURIComponent(Settings.REDIRECT)}`;
        // The current Discord callback needs window.opener.postMessage().
        // Keep its native popup until we replace that authentication handoff.
        const openedWindow = window.open(url, 'oAuthLogin', settings);

        const windowListener = (event) => {
            const { type } = event.data;

            if(type === 'discordOauthLogin'){
               const { code } = event.data;
                try{
                    localStorage.setItem('oauth-handshake', code);
                }catch(e){};
                window.removeEventListener('message', windowListener);
                openedWindow?.close();
                backendManager.backendLogin();
            }
        }

        window.addEventListener('message', windowListener);
    }

    // this.showSettingsMenuButtons = function(){
    //     const targetElement = document.querySelector('#settings-ui');
    //     const volumeButton = document.createElement('button');
    //     volumeButton.classList.add('audioButton');

    //     volumeButton.onclick = ()=>{


    //     }
    //     targetElement.appendChild(volumeButton);
    // }
    this.showSmallLogo = function(){
        if(!smallLogo){
            smallLogo = document.createElement('div');
            smallLogo.classList.add('logoSmall');
            smallLogo.style.position = 'absolute';
            smallLogo.style.top = '0px';
            smallLogo.style.left = '0px';
            smallLogo.style.margin = '4px';
            customGUIContainer.appendChild(smallLogo);
        }
        smallLogo.style.display = 'block';
    }
    this.hideSmallLogo = function(){
        if(smallLogo) smallLogo.style.display = 'none';
    }

    this.showInGameButs = function(){
        if(!inGamePauseButton){
            const margin = 10;
            inGamePauseButton = new Image();
            inGamePauseButton.src = `assets/images/gui/${hashName(`Pause.png`)}`;
            customGUIContainer.appendChild(inGamePauseButton);
            inGamePauseButton.style = `
                position:absolute;
                top:0;
                right:0;
                margin:${margin}px;
                width: 30px;
                height: 53px;
            `;
            inGamePauseButton.classList.add('simple-button');
            inGamePauseButton.onclick = ()=> {
                if(!game.pause){
                    game.pauseGame();
               } else{
                    game.unpauseGame();
               }
            }

            inGameRetryButton = new Image();
            inGameRetryButton.src = `assets/images/gui/${hashName(`Retry.png`)}`;
            customGUIContainer.appendChild(inGameRetryButton);
            inGameRetryButton.style = `
                position:absolute;
                top:0;
                right:40px;
                margin:${margin}px;
                width: 40px;
                height: 54px;
            `;
            inGameRetryButton.classList.add('simple-button');
            inGameRetryButton.onclick = () => {
                game.resetWorld(true);
            }
        }
        if(inGamePauseButton) inGamePauseButton.style.display = 'block';
        if(inGameRetryButton) inGameRetryButton.style.display = 'block';
    }

    this.hideInGameButs = function(){
        if(inGamePauseButton) inGamePauseButton.style.display = 'none';
        if(inGameRetryButton) inGameRetryButton.style.display = 'none';
    }

    this.showSkipTutorialButton = function(){
        if(!skipTutorial){
            skipTutorial = document.createElement('div');
            skipTutorial.classList.add('back-button');
            skipTutorial.style.position = 'absolute';
            skipTutorial.style.top = '0px';
            skipTutorial.style.right = '0px';
            skipTutorial.style.margin = '10px';
            customGUIContainer.appendChild(skipTutorial);
            skipTutorial.innerHTML = `<span class="fit h2">${localize('tutorial_skip_button')}</span>`;
            skipTutorial.onclick = ()=> {
                game.openMainMenu();
                this.hideWinScreen();
                this.hideSkipTutorialButton();
            }
        }
    }
    this.hideSkipTutorialButton = function(){
        if(skipTutorial){
            skipTutorial.parentNode.removeChild(skipTutorial);
            const userData = SaveManager.getLocalUserdata();
            userData.tutorialFinished = true;
            game.tutorialMode = false;
            if(game.showLevelAfterTutorial){
                this.hideMainMenu();
                this.showSinglePlayer();
                this.showLevelBanner(game.showLevelAfterTutorial);
                delete game.showLevelAfterTutorial;
            }
            SaveManager.updateLocalUserData(userData);
        }
        skipTutorial = null;
    }

    this.hide = function () {
        customGUIContainer.style.display = 'none';
    }
    this.show = function () {
        customGUIContainer.style.display = 'block';
    }

    this.hideSinglePlayer = function () {
        if(singlePlayer) singlePlayer.style.display = "none";
        this.hideLevelBanner();
    }

    const replayButtonsHTML = () => /*html*/`
        <div class="replay-buttons">
            <div class="watch-replay">${localize('replay_watch')}</div>
            <div class="share-replay">${localize('replay_share')}</div>
        </div>
    `;
    const setupReplayButtons = (screen, hideScreen) => {
        const share = screen.querySelector('.share-replay');
        screen.querySelector('.watch-replay').onclick = () => {
            const replay = ReplayManager.getCurrentReplay();
            if(!replay) return;
            hideScreen();
            game.playReplay(replay);
        };
        share.onclick = () => {
            const replay = ReplayManager.getCurrentReplay();
            if(!replay) return;
            shareReplayLink(game.replayLink(replay), () => {
                share.innerText = localize('multiplayer_copied');
                setTimeout(() => { share.innerText = localize('replay_share'); }, 2000);
            });
        };
    };
    const updateReplayButtons = screen => {
        const available = ReplayManager.getCurrentReplay() && !ReplayManager.isReplaying() && !game.tutorialMode &&
            game.gameState === game.GAMESTATE_NORMALPLAY && multiplayerState.lobbyState === LOBBY_STATE.OFFLINE;
        screen.querySelector('.replay-buttons').classList.toggle('hidden', !available);
    };

    let lockedEndScreen = null;
    let endScreenUnlockAt = 0;
    this.endScreenInputLocked = () => lockedEndScreen?.style.display === 'block' && performance.now() < endScreenUnlockAt;
    const lockEndScreenInput = (screen, fadeDelay = 0) => {
        lockedEndScreen = screen;
        endScreenUnlockAt = performance.now() + fadeDelay + Settings.endScreenInputDelay;
    };
    const blockLockedClicks = event => {
        if(!this.endScreenInputLocked()) return;
        event.preventDefault();
        event.stopPropagation();
    };

    // After a crash or a finish the player first watches the moment; the end screen
    // follows after Settings.endScreenDelay, or straight away on a click, tap or the flip key.
    let endPrompt = null;
    let endPromptTimer = null;
    let revealPending = null;
    const endPromptText = () => {
        if(MobileController.isMobile()) return localize('end_tap_continue');
        const translate = id => localize(id);
        if(input.gamepad) return localize('end_press_continue', {key: bindingLabel(input.bindings.values.gamepad.flip[0], input.gamepad.mapping === 'standard', translate)});
        const key = input.bindings.values.game.flip[0];
        return key ? localize('end_click_key_continue', {key: bindingLabel(key, true, translate)}) : localize('end_click_continue');
    };
    const showEndPrompt = reveal => {
        if(!endPrompt){
            endPrompt = document.createElement('div');
            endPrompt.classList.add('end-prompt');
            endPrompt.innerHTML = '<div class="text"></div>';
            endPrompt.addEventListener('click', () => this.revealEndScreen());
        }
        endPrompt.querySelector('.text').innerText = endPromptText();
        // Under the rest of the HUD, so the in-game retry and pause buttons keep working.
        customGUIContainer.prepend(endPrompt);
        endPrompt.style.display = 'block';
        clearTimeout(endPromptTimer);
        revealPending = reveal;
        endPromptTimer = setTimeout(this.revealEndScreen, Settings.endScreenDelay);
    };
    const hideEndPrompt = () => {
        clearTimeout(endPromptTimer);
        endPromptTimer = null;
        revealPending = null;
        if(endPrompt) endPrompt.style.display = 'none';
    };
    this.endPromptShown = () => endPromptTimer !== null;
    this.revealEndScreen = () => {
        const reveal = revealPending;
        hideEndPrompt();
        reveal?.();
    };
    const revealGameOver = () => {
        if(!gameOver || !game.run) return;
        gameOver.style.display = 'block';
        lockEndScreenInput(gameOver);
        // Restart the opacity transition now that the screen is displayed.
        void gameOver.offsetWidth;
        gameOver.style.opacity = 1;
        AudioManager.playSFX('lose', 0.3, 1.0);
    };
    const revealWinScreen = () => {
        if(!winScreen) return;
        winScreen.style.display = 'block';
        lockEndScreenInput(winScreen);
    };

    this.showGameOver = function (time, mili){
        if(!gameOver){
            const htmlStructure = /*html*/`
                <div class="result-content">
                    <div class="result-summary">
                        <div class="bar"></div>
                        <div class="sun"></div>
                        <div class="header">${localize('levelgui_youlose')}</div>
                        <div class="time">
                            <div class="text-label">${localize('levelbanner_time')}:</div>
                            <div class="text-time">00:00</div>
                            <div class="text-time-mili">00:00</div>
                        </div>
                    </div>
                    <div class="buttons">
                        <div class="exit">${localize('editorheader_exit')}</div>
                        <div class="test">${localize('levelgui_exittest')}</div>
                        <div class="reset">${localize('levelgui_reset')}</div>
                        <div class="retry">${localize('levelgui_retry')}</div>
                    </div>
                    ${replayButtonsHTML()}
                    <div class="voting">
                        <div class="vote-down button">
                            <div class="vote-thumb"></div>
                        </div>
                        <div class="vote-up button">
                            <div class="vote-thumb"></div>
                        </div>
                    </div>
                    <div class="recommendations">
                    </div>
                </div>
            `;

            gameOver = document.createElement('div');
            gameOver.classList.add('gameover');
            gameOver.innerHTML = htmlStructure;

            const buttons = gameOver.querySelector('.buttons');
            const resetButton = buttons.querySelector('.reset');
            resetButton.onclick = () => {
                if(game.gameState == game.GAMESTATE_EDITOR){
                    game.resetWorld();
                }else{
                    // game.openSinglePlayer(game.currentLevelData);
                    if(game.currentLevelData.forced_vehicle){
                        game.resetWorld();
                    } else {
                        this.showVehicleSelect();
                    }
                }
            };
            const retryButton = buttons.querySelector('.retry');
            retryButton.onclick = () => {
                this.hideGameOverMenu();
                game.resetWorld(true);
            };
            const exitButton = buttons.querySelector('.exit');
            exitButton.onclick = () => {
                this.hideGameOverMenu();

                const multiplayer = multiplayerState.lobbyState !== LOBBY_STATE.OFFLINE;

                if(!multiplayer){
                    game.openSinglePlayer();
                } else if(!multiplayerState.admin){
                    returnToMultiplayer();
                } else {
                    adminReturnToLobby();
                    returnToLobby();
                }
            };

            const testButton = buttons.querySelector('.test');
            testButton.onclick = () => {
                game.stopTestingWorld();
                this.hideGameOverMenu();
            }

            setupReplayButtons(gameOver, () => this.hideGameOverMenu());
            gameOver.addEventListener('click', blockLockedClicks, true);
            customGUIContainer.appendChild(gameOver);
        }
        updateReplayButtons(gameOver);

        const buttons = gameOver.querySelector('.buttons');
        const exitButton = buttons.querySelector('.exit');
        const testButton = buttons.querySelector('.test');

        if(multiplayerState.lobbyState === LOBBY_STATE.OFFLINE){
            exitButton.innerText = localize('editorheader_exit');
        } else {
            exitButton.innerText = localize(multiplayerState.admin ? 'multiplayer_lobby' : 'mainmenu_leave');
        }


        if (game.gameState == game.GAMESTATE_EDITOR) {
            gameOver.classList.add('editor');
        }else{
            gameOver.classList.remove('editor');
        }

        const timeText = gameOver.querySelector('.text-time');
        timeText.innerText = time;
        const miliText = gameOver.querySelector('.text-time-mili');
        miliText.innerText = mili;

        const voteButtons = gameOver.querySelector('.voting');
        const voteUpButton = voteButtons.querySelector('.vote-up');
        const voteDownButton = voteButtons.querySelector('.vote-down');

        shouldShowVoteButton(voteUpButton, voteDownButton, game.currentLevelData);

        this.enableVoteButtons(voteUpButton, voteDownButton, game.currentLevelData);

        this.showRecommendations(gameOver);

        if(game.run){
            gameOver.style.display = 'none';
            showEndPrompt(revealGameOver);
        }
    }

    this.hideGameOverMenu = function () {
        hideEndPrompt();
        if (gameOver && gameOver.style.display == 'block') {
            gameOver.style.display = 'none';
            gameOver.style.opacity = 0;
        }
    }

    this.setSettingsMenuChoice = (element, choice) => {

        const choiceElement = element.querySelector('.choice');
        element.setAttribute('aria-checked', String(Boolean(choice)));

        if(choice){
            choiceElement.classList.add('on');
            choiceElement.classList.remove('off');
            choiceElement.innerText = localize('settings_on');
        }else{
            choiceElement.classList.add('off');
            choiceElement.classList.remove('on');
            choiceElement.innerText = localize('settings_off');
        }

    }

    this.showSettingsMenu = function (){
        controlsPanel?.hide();
        input.setBlocked(true);
        if(game.editor) input.syncEditorModifiers(game.editor);
        if(!settingsMenu){
            const htmlStructure = /*html*/`
                <div class="header">
                    <div class="title">${localize('settings_settings')}</div>
                    <button type="button" class="back">${localize('levelbanner_back')}</button>
                </div>
                <div class="buttons">
                    <div class="settings-options">
                        <button type="button" class="music setting-toggle" role="switch" aria-checked="true"><span>${localize('settings_music')}</span><span class="choice on" aria-hidden="true">${localize('settings_on')}</span></button>
                        <button type="button" class="vocals setting-toggle" role="switch" aria-checked="false"><span>${localize('settings_vocals')}</span><span class="choice off" aria-hidden="true">${localize('settings_off')}</span></button>
                        <button type="button" class="blood setting-toggle" role="switch" aria-checked="true"><span>${localize('settings_blood')}</span><span class="choice on" aria-hidden="true">${localize('settings_on')}</span></button>
                        <button type="button" class="hd setting-toggle" role="switch" aria-checked="true"><span>${localize('settings_hd')}</span><span class="choice on" aria-hidden="true">${localize('settings_on')}</span></button>
                        <button type="button" class="fullscreen setting-toggle" role="switch" aria-checked="false"><span>${localize('settings_fullscreen')}</span><span class="choice off" aria-hidden="true">${localize('settings_off')}</span></button>
                    </div>
                    <button type="button" class="controls setting-toggle"><span>${localize('controls_title')}</span><span aria-hidden="true">→</span></button>
                    <div class="country setting-row">
                        <label for="settings-language">${localize('settings_language')}</label>
                        <select id="settings-language" class="language"></select>
                    </div>
                    <div class="modContainer">
                        <div class="mod"><span>${localize('settings_installedmod')}</span><div class="modname">${localize('settings_none')}</div></div>
                        <a class="install" href="mod.html">${localize('settings_installmod')}</a>
                    </div>
                    <div class="settings-links">
                        <a class="credits" href="https://jollyworld.app/credits/">${localize('settings_credits')}</a>
                        ${Settings.onPoki ? '' : `<button type="button" class="consent">${localize('settings_consent')}</button>`}
                    </div>
                </div>
            `;

            settingsMenu = document.createElement('div');
            settingsMenu.classList.add('settingsmenu');
            settingsMenu.innerHTML = htmlStructure;

            const buttons = settingsMenu.querySelector('.buttons');

            const controlsButton = buttons.querySelector('.controls');
            if(controlsButton) controlsButton.onclick = () => {
                if(!controlsPanel) controlsPanel = new (MobileController.isMobile() ? MobileControlsPanel : ControlsPanel)(customGUIContainer, () => {
                    this.showSettingsMenu();
                    controlsButton.focus();
                });
                settingsMenu.style.display = 'none';
                controlsPanel.show();
            };

            const musicButton = buttons.querySelector('.music');
            musicButton.onclick = ()=> {
                    const userData = SaveManager.getLocalUserdata();
                    userData.musicOn = !userData.musicOn;
                    SaveManager.updateLocalUserData(userData);
                    this.showSettingsMenu();
            }

            const vocalsButton = buttons.querySelector('.vocals');
            if(vocalsLockedOff()) {
                // Voices stay off on this platform; show the state, refuse changes.
                vocalsButton.disabled = true;
                vocalsButton.setAttribute('aria-disabled', 'true');
                vocalsButton.classList.add('locked');
            }
            vocalsButton.onclick = ()=> {
                    if(vocalsLockedOff()) return;
                    const userData = SaveManager.getLocalUserdata();
                    userData.vocalsOn = !userData.vocalsOn;
                    AudioManager.setVocalsDisabled(!userData.vocalsOn);
                    if(!userData.vocalsOn) characterSelectionVoice.stop();
                    SaveManager.updateLocalUserData(userData);
                    this.showSettingsMenu();
            }

            const bloodButton = buttons.querySelector('.blood');
            bloodButton.onclick = ()=> {
                    const userData = SaveManager.getLocalUserdata();
                    userData.bloodOn = !userData.bloodOn;
                    Settings.bloodEnabled = userData.bloodOn;
                    SaveManager.updateLocalUserData(userData);
                    this.showSettingsMenu();
            }

            const hdButton = buttons.querySelector('.hd');
            hdButton.onclick = () => {
                const userData = SaveManager.getLocalUserdata();
                userData.hdOn = !userData.hdOn;
                Settings.HD = userData.hdOn;
                SaveManager.updateLocalUserData(userData);
                game.handleResize();
                this.showSettingsMenu();
            }

            const consentButton = buttons.querySelector('.consent');
            if(consentButton) consentButton.onclick = ()=>{
                if(window.__tcfapi) window.__tcfapi('displayConsentUi', 2, () => {});
            }

            const backButton = settingsMenu.querySelector('.back');
            backButton.onclick = ()=>{
                this.hideSettingsMenu();
            }
            const fullscreenButton = buttons.querySelector('.fullscreen');
            const updateFullscreenChoice = () => this.setSettingsMenuChoice(fullscreenButton, document.fullscreenElement || document.webkitFullscreenElement);
            fullscreenButton.onclick = ()=>{
                MobileController.toggleFullscreen(true);
                updateFullscreenChoice();
            }
            document.addEventListener('fullscreenchange', updateFullscreenChoice);
            document.addEventListener('webkitfullscreenchange', updateFullscreenChoice);

            const languageNames = {us: 'English', de: 'Deutsch', jp: '日本語', pt: 'Português', fr: 'Français', es: 'Español', it: 'Italiano', nl: 'Nederlands', ru: 'Русский', cz: 'Čeština', jr: 'Pirate'};
            const language = buttons.querySelector('.language');
            countries.forEach(country => {
                const option = document.createElement('option');
                option.value = country;
                option.textContent = languageNames[country];
                language.appendChild(option);
            });
            language.value = Settings.currentCountry;
            language.onchange = () => {
                if(language.value === Settings.currentCountry) return;
                const userData = SaveManager.getLocalUserdata();
                userData.country = language.value;
                SaveManager.updateLocalUserData(userData);
                window.location.reload();
            };

            customGUIContainer.appendChild(settingsMenu);
        }

        const userData = SaveManager.getLocalUserdata();

        const buttons = settingsMenu.querySelector('.buttons');

        const musicButton = buttons.querySelector('.music');
        this.setSettingsMenuChoice(musicButton, userData.musicOn);

        const vocalsButton = buttons.querySelector('.vocals');
        this.setSettingsMenuChoice(vocalsButton, !vocalsLockedOff() && userData.vocalsOn);

        const bloodButton = buttons.querySelector('.blood');
        this.setSettingsMenuChoice(bloodButton, userData.bloodOn);

        const hdButton = buttons.querySelector('.hd');
        this.setSettingsMenuChoice(hdButton, userData.hdOn);

        const fullscreenButton = buttons.querySelector('.fullscreen');
        this.setSettingsMenuChoice(fullscreenButton, document.fullscreenElement || document.webkitFullscreenElement);

        const modKey = betterLocalStorage.getItem('jollyModName');
        const modName = buttons.querySelector('.modname');
        modName.innerText = modKey || localize('settings_none');

        settingsMenu.style.display = 'block';
    }
    this.hideSettingsMenu = ()=> {
        if(settingsMenu?.contains(document.activeElement) || controlsPanel?.element.contains(document.activeElement)) document.activeElement.blur();
        controlsPanel?.hide();
        input.setBlocked(false);
        if(settingsMenu){
            settingsMenu.style.display = 'none';
        }
    }

    this.showCharacterSelect = function(){
        if(!characterSelect){
            const htmlStructure = /*html*/`
                <iframe class="mod-frame" title="Character selection" data-menu-frame frameBorder="0" src="./mod.html"></iframe>
            `;

            characterSelect = document.createElement('div');
            characterSelect.classList.add('characterSelect');
            characterSelect.innerHTML = htmlStructure;
            const frame = characterSelect.querySelector('iframe');
            frame.addEventListener('load', () => installExternalLinkRouting(frame.contentDocument));

            customGUIContainer.appendChild(characterSelect);
            let voiceModsReady = Promise.resolve();

            window.addEventListener('message', message => {
                if (message.source !== characterSelect.querySelector('iframe').contentWindow || message.origin !== window.location.origin) return;
                let data;
                try{
                    data = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;
                } catch(e){
                    return;
                }

                try{
                    const {type, character, mask, previewVoice} = data;
                    if(type === 'jollySelectCharacter'){
                        game.selectedCharacter = parseInt(character);
                        game.selectedMask = parseInt(mask);

                        const userData = SaveManager.getLocalUserdata();
                        userData.selectedCharacter = game.selectedCharacter;
                        userData.selectedMask = game.selectedMask;
                        SaveManager.updateLocalUserData(userData);

                        if (previewVoice === true) voiceModsReady.then(() => {
                            if (game.selectedCharacter === Number(character)) characterSelectionVoice.select(game.selectedCharacter);
                        });
                        else if (characterSelectionVoice.skin !== game.selectedCharacter) characterSelectionVoice.stop();

                    } else if(type === 'jollyCloseCharacterSelect'){
                        characterSelectionVoice.hide();
                        characterSelect.style.pointerEvents = 'none';
                        initModManager().then(() => {
                            this.hideCharacterSelect();
                            this.setMainMenuCharacterImage();
                            window.modLoadingDoors();
                            characterSelect.style.pointerEvents = 'all';
                        });
                    } else if(type === 'jollyCleanMod'){
                        characterSelectionVoice.stop();
                        cleanMods();
                    } else if(type === 'jollyModUpdated'){
                        characterSelectionVoice.stop();
                        voiceModsReady = refreshVoiceMods();
                    } else if(type === 'jollyTriggerCommercialBreak') {
                        PokiSDK.commercialBreak();
                    }
                }catch(e){
                    this.hideCharacterSelect();
                }
            });
        }

        characterSelect.style.display = 'block';
        characterSelectionVoice.show();
    }

    this.hideCharacterSelect = function () {
        characterSelectionVoice.hide();
        if(characterSelect){
            characterSelect.style.display = 'none';
        }
    }

    this.setMainMenuCharacterImage = ()=> {
        const grid = mainMenu.querySelector('.menu-grid');
        const characterSelect = grid.querySelector('.character-image');

        getCustomModdedPortrait(`characterselect${game.selectedCharacter+1}.png`, 'assets/images/portraits/').then(url => {
            if(characterSelect) characterSelect.style.backgroundImage = `url(${url})`;
        })
    }

    this.playLevelFromSinglePlayer = function(delay){

        const multiplayer = multiplayerState.lobbyState !== LOBBY_STATE.OFFLINE;

        const continueToGame = ()=>{
            game.preloader.classList.remove('hide');
            setTimeout(()=>{
                this.hideSinglePlayer();
                game.initLevel(game.currentLevelData);
                game.playWorld(true, multiplayer);
                backendManager.increasePlayCountPublishedLevel(game.currentLevelData);
                if(!multiplayer && !game.tutorialMode) game.levelSession.begin(game.currentLevelData.id);

                if(multiplayer){
                    // we want to wait for other players
                    game.run = false;

                    if(multiplayerState.currentGameState >= LOBBY_STATE.LOADING_LEVEL){

                        // the admin is already started, so lets request the game state and already start the countdown
                        multiplayerState.lobbyState = LOBBY_STATE.PLAYING;
                        setMultiplayerHud(HUD_STATES.COUNTDOWN, {ping: 0});
                        multiplayerState.currentGameState = null;

                        // request the game state for the end counter + vote picking
                        requestGameState();
                    } else {
                        setMultiplayerHud(HUD_STATES.WAITING_PLAYERS);
                    }

                    game.gameCamera(true);
                }

                setTimeout(()=>{
                    game.preloader.classList.add('hide');

                    if(multiplayer){
                        sendSimpleMessageAll(SIMPLE_MESSAGE_TYPES.PLAYER_FINISHED_LOADING);
                    }

                }, Settings.levelBuildDelayTime);
            }, Settings.levelBuildDelayTime);
        }

        if(multiplayer){
            this.hideMainMenu();
            continueToGame();

            sendSimpleMessageAll(SIMPLE_MESSAGE_TYPES.SELECT_VEHICLE + game.selectedVehicle);

            // send vehicle choice
        }else{
            PokiSDK.commercialBreak().then(
                () => {
                    continueToGame();
                }
            );
        }
    }

    this.showVehicleSelect = function(){
        if(!vehicleSelect){
            const htmlStructure = /*html*/`
                <div class="bar"></div>
                <div class="header"><span class="fit h1">${localize('vehicleselect_select_vehicle')}</span></div>
                <div class="vehicles">
                </div>
                <div class="back button"><span class="fit h2">${localize('levelbanner_back')}</span></div>
            `;

            vehicleSelect = document.createElement('div');
            vehicleSelect.classList.add('vehicleselect');
            vehicleSelect.innerHTML = htmlStructure;

            const vehicles = vehicleSelect.querySelector('.vehicles');

            for(let i = 0; i<Settings.availableVehicles.length; i++){
                const portrait =  document.createElement('img');

                getModdedPortrait(`vehicle${i+1}.png`, 'assets/images/portraits/').then(url => {
                    if(portrait) portrait.src = url;
                });

                portrait.classList.add('portrait');
                portrait.setAttribute('aria-label', Settings.availableVehicles[i]);
                vehicles.appendChild(portrait);

                portrait.onclick = () => {
                    if (!game.currentLevelData.forced_vehicle || (i + 1) === game.currentLevelData.forced_vehicle) {
                        game.unpauseGame()
                        this.hideVehicleSelect();
                        this.hideWinScreen();
                        this.hideGameOverMenu();
                        this.hidePauseMenu();
                        game.selectedVehicle = i + 1;
                        this.playLevelFromSinglePlayer();
                    }
                }
                // hide no vehicle
                if(i==2) portrait.style.display = 'none';
            }
            vehicleSelect.style.setProperty('--rows', Math.ceil((Settings.availableVehicles.length - 1) / 3));
            customGUIContainer.appendChild(vehicleSelect);
        }

        vehicleSelect.parentNode.appendChild(vehicleSelect);

        vehicleSelect.style.display = 'block';
        vehicleSelect.querySelectorAll('.portrait').forEach((portrait, index) => {
            portrait.dataset.navDisabled = String(Boolean(game.currentLevelData.forced_vehicle && game.currentLevelData.forced_vehicle !== index + 1));
        });
        singlePlayer.classList.add('inactive');

        const back = vehicleSelect.querySelector('.back');
        back.onclick = ()=>{
            this.hideVehicleSelect();
            if(game.gameState === game.GAMESTATE_LOADINGDATA){
                game.gameState = game.GAMESTATE_MENU;
                this.showLevelBanner(game.currentLevelData);
            }
        }

        const multiplayer = multiplayerState.lobbyState !== LOBBY_STATE.OFFLINE;
        if(multiplayer && game.gameState === game.GAMESTATE_LOADINGDATA){
            back.style.display = 'none';
        } else {
            back.style.display = 'block';
        }
    }

    this.hideVehicleSelect = function () {
        if(vehicleSelect){
            vehicleSelect.style.display = 'none';
        }
    }

    this.showPauseMenu = function(){
        if(!pauseScreen){
            const htmlStructure = /*html*/`
                <div class="bar"></div>
                <div class="header">${localize('levelgui_pause')}</div>
                <div class="text-level-name">Level Name Goes Here</div>
                <div class="level-author">
                    <div class="text-level-by">${localize('mainmenu_by')}:</div>
                    <div class="text-author">Author Name</div>
                </div>
                <div class="share">
                    <div class="share-icon"></div>
                    ${localize('levelbanner_share')}
                </div>
                <div class="save">
                    <div class="heart-icon"></div>
                    ${localize('levelbanner_favorite')}
                </div>
                <div class="vote-bar">
                    <div class ="voting">
                        <div class="vote-down button">
                            <div class="vote-thumb"></div>
                        </div>
                        <div class="vote-up button">
                            <div class="vote-thumb"></div>
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <div class="reset">${localize('levelgui_reset')}</div>
                    <div class="retry">${localize('levelgui_retry')}</div>
                    <div class="exit">${localize('editorheader_exit')}</div>
                    <div class="resume">${localize('levelgui_resume')}</div>
                </div>
            `;

            pauseScreen = document.createElement('div');
            pauseScreen.classList.add('pausescreen');
            pauseScreen.innerHTML = htmlStructure;

            const buttons = pauseScreen.querySelector('.buttons');
            const resetButton = buttons.querySelector('.reset');
            resetButton.onclick = () => {
                if(game.currentLevelData.forced_vehicle){
                    game.unpauseGame();
                    game.resetWorld();
                } else {
                    this.showVehicleSelect();
                }
            };
            const retryButton = buttons.querySelector('.retry');
            retryButton.onclick = () => {
                game.unpauseGame();
                game.resetWorld(true);
            };
            const exitButton = buttons.querySelector('.exit');
            exitButton.onclick = () => {
                const multiplayer = multiplayerState.lobbyState !== LOBBY_STATE.OFFLINE;
                game.unpauseGame();

                if(!multiplayer){
                    game.openMainMenu();
                } else if(!multiplayerState.admin){
                    returnToMultiplayer();
                } else {
                    adminReturnToLobby();
                    returnToLobby();
                }
            };
            const resumeButton = buttons.querySelector('.resume');
            resumeButton.onclick = () => {
                game.unpauseGame();
                if(game.run) game.gameplaySession.start();
            };

            customGUIContainer.appendChild(pauseScreen);
        }

        const buttons = pauseScreen.querySelector('.buttons');
        const exitButton = buttons.querySelector('.exit');

        if(multiplayerState.lobbyState === LOBBY_STATE.OFFLINE){
            exitButton.innerText = localize('editorheader_exit');
        } else {
            exitButton.innerText = localize(multiplayerState.admin ? 'multiplayer_lobby' : 'mainmenu_leave');
        }

        const title = pauseScreen.querySelector('.text-level-name');
        title.innerText = game.currentLevelData.title;
        const author = pauseScreen.querySelector('.text-author');
        author.innerText = game.currentLevelData.author.username;

        const voteButtons = pauseScreen.querySelector('.voting');
        const voteUpButton = voteButtons.querySelector('.vote-up');
        const voteDownButton = voteButtons.querySelector('.vote-down');

        const shareButton = pauseScreen.querySelector('.share');
        shareButton.onclick = () => this.showSocialShare(game.currentLevelData);

        const heartButton = pauseScreen.querySelector('.save');
        this.enableHeartButton(heartButton, game.currentLevelData);

        shouldShowVoteButton(voteUpButton, voteDownButton, game.currentLevelData);

        this.enableVoteButtons(voteUpButton, voteDownButton, game.currentLevelData);

        pauseScreen.style.display = 'block';
    }
    this.hidePauseMenu = function () {
        if(pauseScreen){
            pauseScreen.style.display = 'none';
        }
    }

    this.showWinScreen = function(time, mili){
        if(!winScreen){
            const htmlStructure = /*html*/`
                <div class="result-content">
                    <div class="result-summary">
                        <div class="bar"></div>
                        <div class="sun"></div>
                        <div class="header">${localize('levelgui_youwin')}</div>
                        <div class="time">
                            <div class="text-label">${localize('levelbanner_time')}:</div>
                            <div class="text-time">00:00</div>
                            <div class="text-time-mili">00:00</div>
                        </div>
                    </div>
                    <div class="buttons">
                        <div class="exit">${localize('editorheader_exit')}</div>
                        <div class="test">${localize('levelgui_exittest')}</div>
                        <div class="reset">${localize('levelgui_reset')}</div>
                        <div class="retry">${localize('levelgui_retry')}</div>
                    </div>
                    ${replayButtonsHTML()}
                    <div class="voting">
                        <div class="vote-down button">
                            <div class="vote-thumb"></div>
                        </div>
                        <div class="vote-up button">
                            <div class="vote-thumb"></div>
                        </div>
                    </div>
                    <div class="recommendations">
                    </div>
                </div>
            `;

            winScreen = document.createElement('div');
            winScreen.classList.add('winscreen');
            winScreen.innerHTML = htmlStructure;

            const buttons = winScreen.querySelector('.buttons');
            const resetButton = buttons.querySelector('.reset');
            resetButton.onclick = () => {
                if(game.currentLevelData.forced_vehicle){
                    game.resetWorld();
                } else {
                    this.showVehicleSelect();
                }
            };
            const retryButton = buttons.querySelector('.retry');
            retryButton.onclick = () => {
                this.hideWinScreen();
                game.resetWorld(true);
            };
            const exitButton = buttons.querySelector('.exit');
            exitButton.onclick = () => {
                const tutorialMode = game.tutorialMode;

                this.hideWinScreen();

                if(tutorialMode){
                    game.openMainMenu();
                } else {
                    game.openSinglePlayer();
                }
            };

            const testButton = buttons.querySelector('.test');
            testButton.onclick = () => {
                game.stopTestingWorld();
                this.hideWinScreen();
            }

            setupReplayButtons(winScreen, () => this.hideWinScreen());
            winScreen.addEventListener('click', blockLockedClicks, true);
            customGUIContainer.appendChild(winScreen);
        }
        updateReplayButtons(winScreen);

        const buttons = winScreen.querySelector('.buttons');
        const exitButton = buttons.querySelector('.exit');
        const retryButton = buttons.querySelector('.retry');
        const resetButton = buttons.querySelector('.reset');
        const testButton = buttons.querySelector('.test');
        const header = winScreen.querySelector('.header');

        winScreen.style.display = 'none';
        showEndPrompt(revealWinScreen);

        if(game.tutorialMode){
            retryButton.classList.add('hidden');
            resetButton.classList.add('hidden');
        }else{
            retryButton.classList.remove('hidden');
            resetButton.classList.remove('hidden');
        }

        if (game.gameState == game.GAMESTATE_EDITOR) {
            winScreen.classList.add('editor');
        }else{
            winScreen.classList.remove('editor');
        }

        const timeText = winScreen.querySelector('.text-time');
        timeText.innerText = time;
        const miliText = winScreen.querySelector('.text-time-mili');
        miliText.innerText = mili;


        header.innerText = localize('levelgui_youwin');
        let targetlevel = game.currentLevelData.id;
        setTimeout(()=>{
            if(game.currentLevelData.id !== targetlevel) return;
            backendManager.getLeaderboardPosition(game.currentLevelData.id).then(myPositionData => {
                if(header && header.innerText && Array.isArray(myPositionData)){
                    const rank = myPositionData[0].position;
                    if(rank === 1){
                        header.innerText = `${localize('levelgui_youwin')}🥇`;
                    } else if(rank === 2){
                        header.innerText = `${localize('levelgui_youwin')}🥈`;
                    } else if(rank === 3){
                        header.innerText = `${localize('levelgui_youwin')}🥉`;
                    }
                }
            })
        }, 1000)


        const voteButtons = winScreen.querySelector('.voting');
        const voteUpButton = voteButtons.querySelector('.vote-up');
        const voteDownButton = voteButtons.querySelector('.vote-down');

        shouldShowVoteButton(voteUpButton, voteDownButton, game.currentLevelData);

        this.enableVoteButtons(voteUpButton, voteDownButton, game.currentLevelData);

        this.showRecommendations(winScreen);

        if(game.tutorialMode){
            voteButtons.classList.add('hidden');
        }else{
            voteButtons.classList.remove('hidden');
        }

        AudioManager.playSFX('win', 0.5, 1.0);
    }

    this.hideWinScreen = function () {
        hideEndPrompt();
        if(winScreen){
            winScreen.style.display = 'none';
            this.hideSkipTutorialButton();
        }
    }

    this.showRecommendations = target => {
        const recommendations = target.querySelector('.recommendations');
        target.scrollTop = 0;
        target.classList.remove('has-recommendations');

        while(recommendations.children.length>0){
            recommendations.removeChild(recommendations.children[0]);
        }

        if((game.tutorialMode || game.gameState === game.GAMESTATE_EDITOR) || multiplayerState.lobbyState !== LOBBY_STATE.OFFLINE){
            recommendations.style.display = 'none'
            return;
        }

        recommendations.style.display = 'flex';

        const gameTemplate = singlePlayer.querySelector('.game-template');

        const levels = [...initialLevelBatch].sort(() => .5 - Math.random()).filter(level => level.id !== game.currentLevelData.id);


        const compactResults = window.matchMedia('(max-width: 860px), (max-height: 560px)').matches;
        const maxRecommendations = compactResults ? 4 : Math.max(1, Math.floor((window.innerWidth - 24) / (168 + 12)));
        const maxLevels = Math.min(levels.length, maxRecommendations);
        target.classList.toggle('has-recommendations', maxLevels > 0);
        recommendations.style.display = maxLevels > 0 ? 'flex' : 'none';


        let hasAuthorLevel = false;
        for(let i = 0; i<maxLevels; i++){
            if(levels[i].author.username  === game.currentLevelData.author.username){
                hasAuthorLevel = true;
            }
        }

        if(!hasAuthorLevel){
            const authorLevel = levels.find(level => level.author.username === game.currentLevelData.author.username);
            if(authorLevel){
                levels.unshift(authorLevel);
            }
        }

        for(let i = 0; i<maxLevels; i++){
            const recommendedGame = gameTemplate.cloneNode(true)
            recommendedGame.style.display = 'block';
            recommendedGame.classList.remove('game-template')
            const levelData = levels[i];
            this.setLevelDataOnGameTile(recommendedGame, levelData);
            recommendations.appendChild(recommendedGame);
            recommendedGame.onclick = ()=> {
                if (game.gameState === game.GAMESTATE_LOADINGDATA) return;
                game.gameState = game.GAMESTATE_LOADINGDATA;

                target.style.display = 'none';

                this.hideWinScreen();
                game.loadPublishedLevelData(levelData, ()=>{}).then(() => {
                    if(levelData.forced_vehicle){
                        game.selectedVehicle = levelData.forced_vehicle;
                        this.playLevelFromSinglePlayer();
                    }else{
                        this.showVehicleSelect();
                    }
                }).catch(error => {
                    // dafuq
                    target.style.display = 'block';
                });
            }
            imageObserver.observe(recommendedGame);
        }
    }

    this.buildSocialShare = ()=> {
        const htmlStructure = /*html*/`
            <div class="bar"><div class="close"></div></div>
            <div class="header">${localize('share_sharing')}</div>
            <div class="padding">
                <div class="text-level-link">${localize('share_levellink')}</div>
                <div class="copy-url">
                    <input class="text-url" readonly>
                    <div class="copy-button"></div>
                </div>
                <div class="share-by">${localize('share_shareby')}</div>
                <div class="social-share-holder"></div>
            </div>
        `;

        const socialShareElement = document.createElement('div');
        socialShareElement.classList.add('socialshare');
        socialShareElement.innerHTML = htmlStructure;

        const input = socialShareElement.querySelector('input');

        const copyButton = socialShareElement.querySelector('.copy-button');
        copyButton.addEventListener('click', () => {
            const copyText = '(copied) ';
            if (input.value.startsWith(copyText)) {
                input.value = input.value.substr(copyText.length);
            }
            input.select();
            input.setSelectionRange(0, 99999);
            document.execCommand("copy");
            input.value = copyText + input.value;
        });

        const closeButton = socialShareElement.querySelector('.close');
        closeButton.onclick = ()=>{
            socialShareElement.style.display = 'none';
        }

        return socialShareElement;
    }

    this.updateSocialShareLinks = async (element, level) => {
        let url = '';
        if(!Settings.onPoki){
            url = encodeURIComponent(`${Settings.GAMEURI}/?lvl=${level.id}`);
        }else {
            url = await PokiSDK.shareableURL({lvl:level.id});
            url = encodeURIComponent(url);
        }
        const body = encodeURIComponent('Check out this level in JollyWorld! ' + level.description);

        const socialHTML = `
            <a class="resp-sharing-button__link" href="https://facebook.com/sharer/sharer.php?u=${url}" target="_blank" rel="noopener" aria-label="Share on Facebook">
            <div class="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--large"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/></svg>
                </div>Facebook</div>
            </a>
            <a class="resp-sharing-button__link" href="https://twitter.com/intent/tweet/?text=${body}&amp;url=${url}" target="_blank" rel="noopener" aria-label="Share on Twitter">
            <div class="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--large"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"/></svg>
                </div>Twitter</div>
            </a>
            <a class="resp-sharing-button__link" href="whatsapp://send?text=${body}%20${url}" target="_blank" rel="noopener" aria-label="Share on WhatsApp">
            <div class="resp-sharing-button resp-sharing-button--whatsapp resp-sharing-button--large"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.1 3.9C17.9 1.7 15 .5 12 .5 5.8.5.7 5.6.7 11.9c0 2 .5 3.9 1.5 5.6L.6 23.4l6-1.6c1.6.9 3.5 1.3 5.4 1.3 6.3 0 11.4-5.1 11.4-11.4-.1-2.8-1.2-5.7-3.3-7.8zM12 21.4c-1.7 0-3.3-.5-4.8-1.3l-.4-.2-3.5 1 1-3.4L4 17c-1-1.5-1.4-3.2-1.4-5.1 0-5.2 4.2-9.4 9.4-9.4 2.5 0 4.9 1 6.7 2.8 1.8 1.8 2.8 4.2 2.8 6.7-.1 5.2-4.3 9.4-9.5 9.4zm5.1-7.1c-.3-.1-1.7-.9-1.9-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1s-1.2-.5-2.3-1.4c-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6s.3-.3.4-.5c.2-.1.3-.3.4-.5.1-.2 0-.4 0-.5C10 9 9.3 7.6 9 7c-.1-.4-.4-.3-.5-.3h-.6s-.4.1-.7.3c-.3.3-1 1-1 2.4s1 2.8 1.1 3c.1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.3.2-.7.2-1.2.2-1.3-.1-.3-.3-.4-.6-.5z"/></svg>
                </div>WhatsApp</div>
            </a>
            <a class="resp-sharing-button__link" href="https://reddit.com/submit/?url=${url}&amp;resubmit=true&amp;title=${body}" target="_blank" rel="noopener" aria-label="Share on Reddit">
            <div class="resp-sharing-button resp-sharing-button--reddit resp-sharing-button--large"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 11.5c0-1.65-1.35-3-3-3-.96 0-1.86.48-2.42 1.24-1.64-1-3.75-1.64-6.07-1.72.08-1.1.4-3.05 1.52-3.7.72-.4 1.73-.24 3 .5C17.2 6.3 18.46 7.5 20 7.5c1.65 0 3-1.35 3-3s-1.35-3-3-3c-1.38 0-2.54.94-2.88 2.22-1.43-.72-2.64-.8-3.6-.25-1.64.94-1.95 3.47-2 4.55-2.33.08-4.45.7-6.1 1.72C4.86 8.98 3.96 8.5 3 8.5c-1.65 0-3 1.35-3 3 0 1.32.84 2.44 2.05 2.84-.03.22-.05.44-.05.66 0 3.86 4.5 7 10 7s10-3.14 10-7c0-.22-.02-.44-.05-.66 1.2-.4 2.05-1.54 2.05-2.84zM2.3 13.37C1.5 13.07 1 12.35 1 11.5c0-1.1.9-2 2-2 .64 0 1.22.32 1.6.82-1.1.85-1.92 1.9-2.3 3.05zm3.7.13c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm9.8 4.8c-1.08.63-2.42.96-3.8.96-1.4 0-2.74-.34-3.8-.95-.24-.13-.32-.44-.2-.68.15-.24.46-.32.7-.18 1.83 1.06 4.76 1.06 6.6 0 .23-.13.53-.05.67.2.14.23.06.54-.18.67zm.2-2.8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5.7-2.13c-.38-1.16-1.2-2.2-2.3-3.05.38-.5.97-.82 1.6-.82 1.1 0 2 .9 2 2 0 .84-.53 1.57-1.3 1.87z"/></svg>
                </div>Reddit</div>
            </a>
            <a class="resp-sharing-button__link" href="mailto:?subject=${body}&amp;body=${url}" target="_self" rel="noopener" aria-label="Share by E-Mail">
            <div class="resp-sharing-button resp-sharing-button--email resp-sharing-button--large"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z"/></svg></div>E-Mail</div>
            </a>
            <a class="resp-sharing-button__link" href="http://vk.com/share.php?title=${body}&amp;url=${url}" target="_blank" rel="noopener" aria-label="Share on VK">
            <div class="resp-sharing-button resp-sharing-button--vk resp-sharing-button--large"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.547 7h-3.29a.743.743 0 0 0-.655.392s-1.312 2.416-1.734 3.23C14.734 12.813 14 12.126 14 11.11V7.603A1.104 1.104 0 0 0 12.896 6.5h-2.474a1.982 1.982 0 0 0-1.75.813s1.255-.204 1.255 1.49c0 .42.022 1.626.04 2.64a.73.73 0 0 1-1.272.503 21.54 21.54 0 0 1-2.498-4.543.693.693 0 0 0-.63-.403h-2.99a.508.508 0 0 0-.48.685C3.005 10.175 6.918 18 11.38 18h1.878a.742.742 0 0 0 .742-.742v-1.135a.73.73 0 0 1 1.23-.53l2.247 2.112a1.09 1.09 0 0 0 .746.295h2.953c1.424 0 1.424-.988.647-1.753-.546-.538-2.518-2.617-2.518-2.617a1.02 1.02 0 0 1-.078-1.323c.637-.84 1.68-2.212 2.122-2.8.603-.804 1.697-2.507.197-2.507z"/></svg>
                </div>VK</div>
            </a>
            <a class="resp-sharing-button__link" href="https://telegram.me/share/url?text=${body}&amp;url=${url}" target="_blank" rel="noopener" aria-label="Share on Telegram">
            <div class="resp-sharing-button resp-sharing-button--telegram resp-sharing-button--large"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M.707 8.475C.275 8.64 0 9.508 0 9.508s.284.867.718 1.03l5.09 1.897 1.986 6.38a1.102 1.102 0 0 0 1.75.527l2.96-2.41a.405.405 0 0 1 .494-.013l5.34 3.87a1.1 1.1 0 0 0 1.046.135 1.1 1.1 0 0 0 .682-.803l3.91-18.795A1.102 1.102 0 0 0 22.5.075L.706 8.475z"/></svg>
                </div>Telegram</div>
            </a>
        `;
        const holder = element.querySelector('.social-share-holder');
        holder.innerHTML = socialHTML;

        const input = element.querySelector('input');
        input.value = decodeURIComponent(url);

    }

    this.showSocialShare = level =>{
        if(!socialShareScreen){
            socialShareScreen = this.buildSocialShare();
            customGUIContainer.appendChild(socialShareScreen);
        }
        this.updateSocialShareLinks(socialShareScreen, level);
        socialShareScreen.style.display = 'block';
    }

    this.hideSocialShareMenu = function () {
        if (socialShareScreen) socialShareScreen.style.display = 'none';
    }

    this.showYouTubePlayer = function(id){
        if(!youtubePlayer){
            youtubePlayer = document.createElement('div');
            const closeFunction = ()=>{
                this.hideYouTubePlayer();
            }
            youtubePlayer = this.buildYouTubePlayer(youtubePlayer, closeFunction)
            customGUIContainer.appendChild(youtubePlayer);
        }

        levelBanner.style.visibility = 'hidden';

        this.setYouTubePlayer(youtubePlayer, id);

        youtubePlayer.style.display = 'block';
    }

    this.setYouTubePlayer = (player, id) => {
        const footer = player.querySelector('.footer');
        const author = footer.querySelector('.text-author');
        const subscribe = footer.querySelector('.subscribe-button');
        const spinner = player.querySelector('.spinner');

        YouTubePlayer.loadVideo('YTPlayerHolder', id, author, subscribe,spinner);

        const subscribeButton = footer.querySelector('.subscribe-button');
        subscribeButton.onclick = ()=>{
            const channelID = subscribeButton.getAttribute('yt-channel');
            if(channelID){
                openExternalLink(`https://www.youtube.com/channel/${channelID}?view_as=subscriber&sub_confirmation=1`);
            }
        }
    }

    this.buildYouTubePlayer = function(targetDiv, closeFunction, compact){
        const htmlStructure =
        /*html*/`
        ${compact ? '' : `<div class="bar"><div class="close"></div></div>`}
        <div id="YTPlayerHolder" class="yt-iframe"></div>
        <div class="spinner">
            ${YouTubePlayer.spinnerHTML}
        </div>
        <div class="footer">
            <div class="text-author"></div>
            <div class="subscribe-button">
                ${YouTubePlayer.subscribeButtonHTML}
            </div>
        </div>
        `;

        targetDiv.innerHTML = htmlStructure;

        if(!compact){
            targetDiv.classList.add('youtubeplayer');
            const close = targetDiv.querySelector('.close');
            close.onclick = closeFunction;
        }else{
            targetDiv.classList.add('youtubeplayercompact');
        }


        if(Settings.onPoki){
            const subscribeButton = targetDiv.querySelector('.subscribe-button');
            subscribeButton.style.display = 'none';
        }

        return targetDiv;
    }

    this.hideYouTubePlayer = function(){
        if(youtubePlayer){
            levelBanner.style.visibility = 'visible';
            youtubePlayer.style.display = 'none';
            YouTubePlayer.stopVideo();
        }
    }

    this.showDiscordJoin = (state = 'invite') => {
        if(!discordJoin){
            discordJoin = document.createElement('div');
            discordJoin.classList.add('discordJoin');
            customGUIContainer.appendChild(discordJoin);
        }

        const standing = backendManager.userData?.discord_level;
        const rank = standing ? rankForLevel(standing.level) : null;
        const rankName = rank ? `<span class="rank-name">${rank.name}</span>` : '';
        const glyph = '<span class="discord-glyph" aria-hidden="true"></span>';
        const perkIcon = path => `<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">${path}</svg>`;

        let htmlStructure;
        if(state === 'joined'){
            htmlStructure = /*html*/`
                <h2 class="banner">${localize('discord_joined_title')}</h2>
                ${rank ? '<div class="rank-icon big"></div>' : '<div class="billyDiscord"></div>'}
                <div class="welcome"></div>
                <div class="content">${rank ? localize('discord_joined_body', {rank: rankName}) : localize('discord_joined_body_unranked')}</div>
                <button type="button" class="open">${glyph}${localize('discord_open')}</button>
                <button type="button" class="back">${localize('discord_backtogame')}</button>
            `;
        }else if(state === 'failed'){
            htmlStructure = /*html*/`
                <h2 class="header small">${localize('discord_failed_title')}</h2>
                <div class="content">${localize('discord_failed_body')}</div>
                <div class="buttons">
                    <button type="button" class="open">${localize('discord_invite')}</button>
                    <button type="button" class="back">${localize('levelbanner_back')}</button>
                </div>
            `;
        }else{
            htmlStructure = /*html*/`
                <h2 class="header">${localize(rank ? 'discord_popup_title' : 'discord_getinvolved')}</h2>
                <div class="billyDiscord"></div>
                ${rank ? /*html*/`
                <div class="joinas">
                    <div class="rank-icon"></div>
                    <div class="joinas-text">
                        <span class="label">${localize('discord_popup_joinas')}</span>
                        <span class="joinas-rank">${rankName}<span class="level">${localize('rank_level', {level: standing.level})}</span></span>
                    </div>
                </div>` : ''}
                <ul class="perks">
                    <li>${perkIcon('<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/>')}${localize('discord_perk_chat')}</li>
                    <li>${perkIcon('<path d="M4 10v4h3l6 4V6L7 10H4z"/><path d="M17 9a4 4 0 0 1 0 6"/>')}${localize('discord_perk_updates')}</li>
                    <li>${perkIcon('<path d="M12 3l2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.8z"/>')}${localize('discord_perk_rank')}</li>
                </ul>
                <button type="button" class="join">${glyph}<span class="label">${localize('discord_join')}</span></button>
                <button type="button" class="back">${localize('discord_notnow')}</button>
                ${Settings.onPoki ? '' : `<p class="note">${localize('discord_popup_note')}</p>`}
            `;
        }

        discordJoin.dataset.state = state;
        discordJoin.dataset.rank = rank ? rank.id : 'none';
        discordJoin.innerHTML = htmlStructure;

        const billyDiscord = discordJoin.querySelector('.billyDiscord');
        if(billyDiscord) billyDiscord.style.backgroundImage = `url(assets/images/misc/${hashName('jollyDiscord.png')})`;
        const rankIcon = discordJoin.querySelector('.rank-icon');
        if(rankIcon) showRankIcon(rankIcon, rank);
        const welcome = discordJoin.querySelector('.welcome');
        if(welcome) welcome.textContent = localize('discord_joined_welcome', {name: backendManager.userData?.username || ''});

        discordJoin.querySelector('.join')?.addEventListener('click', () => {
            this.joinDiscord();
            if(Settings.onPoki) this.hideDiscordJoin();
        });
        discordJoin.querySelector('.open')?.addEventListener('click', () => {
            openExternalLink(state === 'joined' ? discordServerUrl : discordInviteUrl);
            if(state === 'failed') refreshDiscordOnReturn();
            this.hideDiscordJoin();
        });
        discordJoin.querySelector('.back').onclick = () => this.hideDiscordJoin();

        if(state === 'invite'){
            const userData = SaveManager.getLocalUserdata();
            userData.discordJoinShown = true;
            SaveManager.updateLocalUserData(userData);
        }

        singlePlayer?.classList.add('inactive');
        customGUIContainer.appendChild(discordJoin);
        discordJoin.style.display = 'block';
    }

    this.hideDiscordJoin = () => {
        if(!discordJoin) return;
        discordJoin.style.display = 'none';
        singlePlayer?.classList.remove('inactive');
    }

    this.showServerDown = () => {
        if(!serverDown){
            serverDown = document.createElement('div');
            serverDown.classList.add('serverDown');
            serverDown.innerHTML = /*html*/`
                <div class="window" role="alertdialog" aria-labelledby="server-down-title">
                    <h2 class="header" id="server-down-title">${localize('server_down_title')}</h2>
                    <div class="content">${localize('server_down_body')}</div>
                    <button type="button" class="retry">${localize('server_down_retry')}</button>
                    ${Settings.onPoki ? '' : `<button type="button" class="discord"><span class="discord-glyph" aria-hidden="true"></span>${localize('server_down_discord')}</button>`}
                    <p class="note">${localize('server_down_note')}</p>
                </div>
            `;

            const retry = serverDown.querySelector('.retry');
            retry.onclick = () => {
                retry.disabled = true;
                retry.textContent = localize('server_down_checking');
                backendManager.checkServer().then(() => {
                    retry.disabled = false;
                    retry.textContent = localize('server_down_retry');
                });
            };
            serverDown.querySelector('.discord')?.addEventListener('click', () => openExternalLink(discordInviteUrl));
        }
        customGUIContainer.appendChild(serverDown);
        serverDown.style.display = 'block';
    }

    this.hideServerDown = () => {
        if(serverDown) serverDown.style.display = 'none';
    }

    this.FILTER_SORT_MOSTPLAYED = "mostplayed";
    this.FILTER_SORT_BEST = "best";
    this.FILTER_SORT_NEWEST = "newest";
    this.FILTER_SORT_OLDEST = "oldest";
    this.FILTER_SORT_RECENTLY = "recently";

    this.FILTER_RANGE_TODAY = "today";
    this.FILTER_RANGE_THISWEEK = "week";
    this.FILTER_RANGE_THISMONTH = "month";
    this.FILTER_RANGE_ANYTIME = "anytime";
}
export var ui = new UIManager();
configureMenuNavigation(ui, () => game, () => MobileController.isMobile());

const shouldShowVoteButton = (up, down, levelData) => {
    const vote = BackendCache.voteDataCache[levelData.id];

    up.classList.remove('disabled');
    down.classList.remove('disabled');

    if (vote) {
        if (vote > 0) {
            down.classList.add('disabled');
        } else {
            up.classList.add('disabled');
        }
    }
}

const shouldShowHeartButton = (heart, levelData) => {
    heart.classList.remove('faved');

    const fave = BackendCache.favoriteDataCache[levelData.id];
    if (fave) {
        heart.classList.remove('disabled');
    }else{
        heart.classList.add('disabled');
    }
}
